/* exported td, checkPopupWidth, clickedCallDropdownToggle, closeTransferMode, getMonitorId,
 createConfirmCallOptionsDock, createConfirmCallPopover, dialWithPhoneOption, dockHeight,
 dockModifyCallsameURI, dockShowCall, durationCounter, escapeCallid, generateDeviceOptions,
 generateDeviceOptionsPopoverContent, getButtons, getCallKey, updateCallLineUserPopout,
 getName, getNumber, getStatus, getType, getUserDevices, initConfirmCall, updateNotes,
 initTransferMode, listenIn, lookupDefaultDevice, notifyInbound, plainTextNotification,
 popoutModifyCallsameURI, popoutShowCall, popupShowScreenshare, popupShowScreenshare2,
 sendDispostion, setCustom, setDialPadOptions, sGetCallsData, showDialPad, startVideo,
 transferCallDirect, uncheckDefaultDeviceBox, updateCallLineDomain, updateCallLineUser,
 unregisterCallLineContext */
/* global subDomain, subUser, cleanDevice, cleanDevicePrep, recordCallButton, popupShowNotes,
 dispositionList, addAutoCompleteTransfer, hideInboundConferencePopups, isWebrtc, NsAgentsMain,
 SNAPmobileWebenabled, SNAPmobileWebName, homeVoicemail, getCount, popupAllowComplete, Cookies,
 currentServerName, sipCall, toggleFullScreen, cleanId, portalHomeOmpShowMeetings,
 getDuration, portalAgentScreenPopUrl, portalAgentScreenPopUrl, portalHtml5Notifications,
 launchWebPhone, clickToDial, getDropdownDirection, subscribeOnce, hideAgentMsgRecord,
 greetingsTableHeight, portalClickToCallUseAuto, reverseContactLookup, generateSessionId,
 UiConfigReaderComponent */
var timeOffset = 0;
var ignoreOrigId = [];
var intendedAnsOrigId = [];
var ignoreTermId = [];
var monitorIds = [];
var callHistoryLookupScheduled = false;
var callToTransfer = {};
var vMailLookupScheduled = false;
var audioMonitoringtoClearOnHangup = [];
var callbackIds = [];
var timeoutReference;
var notifyArray = {};
var myCalls = [];
var modalLoadingHtml = `<div class="loading-container relative">
    <div class="loading-spinner la-ball-spin-clockwise">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>`;

Object.size = function (obj) {
  return Object.keys(obj).length;
};

function td(str, classStr) {
  if (typeof classStr === 'undefined') {
    classStr = '';
  }

  return '<td class="' + classStr + '">' + str + '</td>';
}

function sGetVoicemailData(domain, filter) {
  if (socket === undefined) {
    return;
  }

  var options = {
    domain: domain,
    type: 'voicemail',
  };

  if (!(filter != null && filter !== '' && filter !== '*')) {
    return;
  }

  options.filter = filter;

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscribeOnce(options);
    });

  bindVoicemailSocketHandlers();
}

var voicemailSocketHandlersBound = false;

/**
 * Bind the voicemail socket handler exactly once. sGetVoicemailData() is called
 * from the layout's 'connect' handler, which fires again on every reconnect, so
 * registering inline meant every voicemail event triggered one getCount() per
 * reconnect the session had survived.
 */
function bindVoicemailSocketHandlers() {
  if (voicemailSocketHandlersBound || typeof socket === 'undefined') {
    return;
  }

  voicemailSocketHandlersBound = true;

  socket.on('voicemail', function (data) {
    log('voicemail socket data received');
    log(data);
    getCount();
  });
}

function getStatus(value) {
  if (value.term_uri == 'Call-Queue' || value.term_uri == 'Auto-Attendant') {
    return _('Waiting');
  }

  if (value.time_answer == '0000-00-00 00:00:00') {
    return _('Ringing Agent');
  }

  if (value.orig_call_info === 'held' && value.term_call_info === 'held') {
    return _('On Hold');
  }

  return _('Talking');
}

function getButtons(callData, includeTd) {
  if (includeTd == null) {
    includeTd = true;
  }

  var buttons = '&nbsp;';
  var buttonClasses = 'btn btn-default btn-xs helpsy';

  if ($('#calls_table').hasClass('allowmonitor')) {
    buttonClasses += ' listen-in-btn-queue';
    buttons = '<a href="javascript:void(0)" class="' + buttonClasses + '" title="' + _('Listen in') + '"><i class="fa fa-volume-up"></i></a>';
  }

  if ($('#agents-table').hasClass('allowmonitor')) {
    buttonClasses += ' listen-in-btn';
    buttons = '<a href="javascript:void(0)" class="' + buttonClasses + '" title="' + _('Listen in') + '"><i class="fa fa-volume-up"></i></a>';
  }

  if (callData.term_uri == 'Call-Queue'
    || callData.term_uri == 'Auto-Attendant'
    || callData.time_answer == '0000-00-00 00:00:00'
  ) {
    buttons = '&nbsp;';
  }

  buttons = '<div class="action-buttons-inner">' + buttons + '</div>';

  if (includeTd) {
    buttons = '<td class="action-buttons">' + buttons + '</td>';
  }

  return buttons;
}

/**
 * get object of user devices from local storage or API
 *
 * @param {boolean} force will force the retrieval of devices from the API instead of local storage
 * @param {function} callback is the function that will be executed after retrieving
 * the user devices
 * */
function getUserDevices(force, callback) {
  var userDevices = JSON.parse(localStorage.getItem('userDevices'));

  if (!force
    && userDevices != null
    && typeof userDevices !== 'undefined'
    && typeof userDevices.timestamp !== 'undefined'
  ) {
    var ts = userDevices.timestamp;
    var now = Date.now();
    var diff = now - ts;

    if ((diff / 1000) > 120) {
      // 120s
      userDevices = null;
    } else if (!force) {
      setTimeout(function () {
        getUserDevices(true, callback);
      }, 1500);
    }
  }

  if (typeof userDevices === 'undefined' || userDevices == null || force) {
    var arg = {
      object: 'device',
      action: 'list',
      user: subUser,
      domain: subDomain,
      noNDP: 'yes',
      format: 'json',
      mode: 'registered_endpoint',
    };

    netsapiens.api.post(arg, function (data) {
      userDevices = {
        value: 'value',
        timestamp: Date.now(),
        devices: data,
      };

      callback(data);
      localStorage.setItem('userDevices', JSON.stringify(userDevices));
    });
  } else {
    callback(userDevices.devices);
  }
}

/**
 * get the default device from local storage if it exists
 *
 * @returns {string} defaultDevice is the name/identifier of the default phone
 * */
function lookupDefaultDevice() {
  var defaultDevice = subUser;

  if (localStorage.getItem('click2callphonedefaultvalue') != null) {
    defaultDevice = localStorage.getItem('click2callphonedefaultvalue');
  }

  return defaultDevice;
}

// calculates height of dock columns and overlay based on window height
function dockHeight() {
  var dockDivs = $('.dock-overlay-inner, .dock-column, .dock-column-inner');

  dockDivs.height($(window).height());
}

function getCallKey(call) {
  var keyParts = [];

  if (call.orig_callid) {
    keyParts.push(call.orig_callid);
  }

  if (call.term_callid) {
    keyParts.push(call.term_callid);
  }

  if (call.term_uri) {
    keyParts.push(call.term_uri);
  }

  return keyParts.join('').replace(/[^a-zA-Z0-9]/g, '');
}

function getType(value, domain, user) {
  if (value.orig_callid.indexOf('adhoc.monitor') !== -1) {
    return 'monitor';
  }

  if (value.term_callid.indexOf('adhoc.monitor') !== -1) {
    return 'monitor';
  }

  if (value.term_uri.indexOf('adhoc.monitor') !== -1) {
    return 'monitor';
  }

  if (value.dnis.indexOf('adhoc.monitor') !== -1) {
    return 'monitor';
  }

  if (value.term_user == user && value.term_domain == domain) {
    return 'inbound';
  }

  if (value.by_user == user && value.by_domain == domain) {
    return 'inbound';
  }

  return 'outbound';
}

function getNumber(value, domain, user) {
  if (value.orig_callid.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  if (value.term_callid.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  if (value.term_uri.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  if (value.term_user == user && value.term_domain == domain) {
    return cleanDevice(value.orig_from_uri);
  }

  if (value.by_user == user && value.by_domain == domain) {
    return cleanDevice(value.orig_from_uri);
  }

  return cleanDevice(value.term_uri);
}

function getName(value, domain, user, number) {
  if (value.orig_callid.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  if (value.term_callid.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  if (value.term_uri.indexOf('adhoc.monitor') !== -1) {
    return '&nbsp;';
  }

  number = cleanDevicePrep(number);

  if (number.length > 10) {
    number = number.replace(new RegExp('^[1]+'), '');
  }

  if (reverseContactLookup[number]) {
    return reverseContactLookup[number];
  }

  if (number.length === 10 && reverseContactLookup['1' + number]) {
    return reverseContactLookup['1' + number];
  }

  if (value.term_user == user && value.term_domain == domain) {
    return value.orig_name;
  }

  if (value.by_user == user && value.by_domain == domain) {
    return value.orig_name;
  }

  return '&nbsp;';
}

function getMonitorId(value) {
  var monId = 'notmonitored';

  if (value.dnis.indexOf('adhoc.monitor') !== -1) {
    monId = value.dnis;
  } else if (value.orig_callid.indexOf('adhoc.monitor') !== -1) {
    monId = value.orig_callid;
  } else if (value.term_callid.indexOf('adhoc.monitor') !== -1) {
    monId = value.term_callid;
  } else if (value.term_uri.indexOf('adhoc.monitor') !== -1) {
    monId = value.term_uri;
  }

  return monId.replace('callrequest.', '');
}

function escapeCallid(callid) {
  return callid.replace(':', 'COLON').replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON')
    .replace(':', 'COLON');
}

function updateNotes(callId) {
  Cookies.set('notes' + callId, $('#' + callId + ' .dockcall-notes').val(), { expires: 1 });

  if (!timeoutReference) {
    return;
  }

  timeoutReference = null;
}

function initTransferMode(call) {
  callToTransfer = call;

  // flag read by NSDockRoster so contact rows rendered mid-transfer match
  window.dockTransferModeActive = true;

  $('.transfermode').show();
  $('.nontransfermode').hide();
}

function closeTransferMode() {
  window.dockTransferModeActive = false;

  $('.transfermode').hide();
  $('.nontransfermode').show();
}

function plainTextNotification(image, title, content) {
  if (window.webkitNotifications.checkPermission() == 0) {
    return window.webkitNotifications.createNotification(image, title, content);
  }

  return null;
}

function sendDispostion(columnId) {
  log('sendDispostion');
  log(columnId);

  var url = '/portal/callhistory/notes/' + $(columnId).data('orig_callid') + '/' + $(columnId).data(
    'term_callid',
  );

  if ($(columnId).data('batch_tim_beg') != null && $(columnId).data('batch_tim_beg') != '') {
    url += '/' + escapeCallid($(columnId).data('batch_tim_beg'));
  }

  var data = $('#dispForm').serialize();

  log(url);
  log(data);
  $.post(url, data, $.noop)
    .fail(console.error)
    .done(function () {
      jsFlash(_('Notes Saved'), 'success');
    });
}

function notifyInbound(callid, cname, number, clean) {
  if ($(window).data('prevType') != 'blur') {
    return;
  }

  if (window.webkitNotifications) {
    if (typeof notifyArray[callid] !== 'undefined') {
      return;
    }

    notifyArray[callid] = plainTextNotification('/portal/img/buttons/inbound.png', cname, clean);

    if (notifyArray[callid] === null) {
      return;
    }

    notifyArray[callid].show();

    notifyArray[callid].ondisplay = function (event) {
      setTimeout(function () {
        event.currentTarget.cancel();
      }, 10000);
    };

    notifyArray[callid].onclick = function () {
      if (typeof portalAgentScreenPopUrl !== 'undefined' && portalAgentScreenPopUrl != '') {
        window.open('http://www.google.com/?q=' + number, '_blank');
      }

      notifyArray[callid].close();
      notifyArray.splice(callid, 1);
    };
  } else {
    log('Notifications are not supported for this Browser/OS version yet.');
  }
}

// checks the width of the window and dock-popup-overlay to show or hide popups
function checkPopupWidth() {
  var overlayWidth = $('.dock-popup-overlay').outerWidth(true);
  var windowWidth = $(window).width();

  if (overlayWidth == windowWidth) {
    // hide the last chatbox -- should this only hide chat boxes and not calls?
    $('.dock-popup-overlay .dock-column:visible')
      .last()
      .hide();
  } else if ((overlayWidth + 270) < windowWidth) {
    // check if overlay has room to show another chat box
    $('.dock-popup-overlay .dock-column:hidden')
      .first()
      .show();
  }
}

function dockModifyCallsameURI(dock, value, domain, user) {
  var url;
  var thisId = dock.attr('id');
  var columnId = '#' + thisId;
  var dockBody = columnId + ' .dockcall-body';
  var callButtons = columnId + ' .dockcall-buttons';
  var callMonitor = columnId + ' .dockcall-monitor';
  var answerButton = columnId + ' .dockcall-answer';
  var origNumber = columnId + ' .dockcall-orignumber';
  var disposition = columnId + ' .dockcall-disposition';
  var endButton = columnId + ' .dockcall-end';
  var holdButton = columnId + ' .dockcall-hold';
  var reason = columnId + ' .dockcall-reason';
  var notes = columnId + ' .dockcall-notes';
  var origName = columnId + ' .dockcall-origname';
  var termNumber = columnId + ' .dockcall-termnumber';
  var panelContent = columnId + ' .dockcall-panel-content';
  var panelInfo = columnId + ' .dockcall-info';
  var monitorActionsBarge = columnId + ' .barge-btn';
  var monitorActionsOrig = columnId + ' .wisper-orig-btn';
  var monitorActionsTerm = columnId + ' .wisper-term-btn';
  var monitorActionsListen = columnId + ' .listen-btn';
  var recordBtn = columnId + ' .dockcall-record';
  var transButton = columnId + ' .dockcall-transfer';
  var callType = getType(value, domain, user);
  var number = getNumber(value, domain, user);
  var name = getName(value, domain, user, number);

  /** @type {array} */
  var termIds = dock.data('termIds');
  var termid = value.term_callid.replace(/[^a-zA-Z0-9]/g, '-');
  var termIdFound = false;

  termIds.forEach(function (val) {
    if (val == termid) {
      termIdFound = true;
    }
  });

  if (value.orig_from_user == 'PromptRetrieve' || value.orig_from_user == 'PromptRetrieve') {
    if (typeof ignoreOrigId != 'undefined') {
      ignoreOrigId.push(value.orig_callid);
    }

    $(columnId).remove();

    return;
  }

  if (name == 'PromptRetrieve' || name == 'PromptRetrieve') {
    if (typeof ignoreOrigId != 'undefined') {
      ignoreOrigId.push(value.orig_callid);
    }

    $(columnId).remove();

    return;
  }

  if (value.by_action == 'XferSup' && subUser == value.by_sub) {
    if (typeof ignoreOrigId != 'undefined') {
      ignoreOrigId.push(value.orig_callid);
    }

    $(columnId).remove();

    return;
  }

  if (value.term_to_uri == 'VMail' && subUser == value.term_sub) {
    if (typeof ignoreOrigId != 'undefined') {
      ignoreOrigId.push(value.orig_callid);
    }

    $(columnId).remove();

    return;
  }

  $(columnId).data('term_callid', value.term_callid);

  if (!termIdFound && typeof termIds.push === 'function') {
    termIds.push(termid);
  }

  var curLegCount = parseInt($(columnId).data('legCount'), 10);

  log('curLegCount=' + curLegCount);

  if (callType == 'monitor') {
    log('calltype monnitor searching : ');
    log(value.orig_call_info);

    if (value.term_logi_uri.indexOf('conference-bridge')) {
      $(columnId).data('confbridge_id', value.term_logi_uri);
    }

    if (value.orig_call_info.indexOf('orig') !== -1) {
      if (typeof $(columnId).data('orig_tap_callid') !== 'undefined') {
        $(columnId).data('legCount', curLegCount + 1);
      }

      $(columnId).data('orig_tap_callid', value.term_callid);
      $(columnId).data('tap_callid', value.by_callid);

      log('origIsAgent?');
      log(value);
      $(columnId).data('origIsAgent', value.by_callid);
      log('found the orig leg ' + $(columnId).data('orig_tap_callid'));
    } else if (value.orig_call_info.indexOf('term') !== -1) {
      if (typeof $(columnId).data('term_tap_callid') !== 'undefined') {
        $(columnId).data('legCount', curLegCount + 1);
      }

      $(columnId).data('term_tap_callid', value.term_callid);
      $(columnId).data('tap_callid', value.by_callid);
      log('found the term leg ' + $(columnId).data('term_tap_callid'));
    } else if (value.orig_call_info.indexOf('tap-listen') !== -1) {
      if (typeof $(columnId).data('tap-listen1') !== 'undefined') {
        if ($(columnId).data('tap-listen1') != value.term_callid) {
          if ($(columnId).data('tap-listen2') != value.term_callid) {
            if ($(columnId).data('tap-listen1') != value.term_callid) {
              $(columnId).data('legCount', curLegCount + 1);
            }
          }

          $(columnId).data('tap-listen2', value.term_callid);
          $(columnId).data('tap_callid', value.by_callid);
          log('found a unknown leg 2 ' + $(columnId).data('tap-listen2'));
        }
      } else {
        if (typeof $(columnId).data('tap-listen1') === 'undefined') {
          $(columnId).data('legCount', curLegCount + 1);
        }

        $(columnId).data('tap-listen1', value.term_callid);
        $(columnId).data('tap_callid', value.by_callid);
        log('found a unknown leg 1 ' + $(columnId).data('tap-listen1'));
      }
    }

    log('active call legs for monitor is ' + $(columnId).data('callLeg'));
    curLegCount = parseInt($(columnId).data('legCount'), 10);

    log('Two valid Legs check');

    if ((typeof $(columnId).data('term_tap_callid') !== 'undefined'
      && typeof $(columnId).data('orig_tap_callid') !== 'undefined')
      || curLegCount == 2
    ) {
      log('Two valid Legs');

      var allowWisper = true;
      var allowWisperHalf = false;

      if (typeof $(columnId).data('tap-listen2') !== 'undefined') {
        allowWisper = false;
      }

      if (typeof $(columnId).data('term_tap_callid') !== 'undefined'
        || typeof $(columnId).data('term_tap_callid') !== 'undefined'
      ) {
        // have half a leg correct...
        allowWisperHalf = true;
      }

      if (typeof $(columnId).data('term_tap_callid') === 'undefined'
        || typeof $(columnId).data('orig_tap_callid') === 'undefined'
      ) {
        if (!allowWisperHalf) {
          allowWisper = false;
        }

        // unknown orig/term.
        if (typeof $(columnId).data('orig_tap_callid') === 'undefined') {
          $(columnId).data('orig_tap_callid', $(columnId).data('tap-listen1'));

          if (typeof $(columnId).data('term_tap_callid') === 'undefined') {
            $(columnId).data('term_tap_callid', $(columnId).data('tap-listen2'));
          }
        } else if (typeof $(columnId).data('term_tap_callid') === 'undefined') {
          $(columnId).data('term_tap_callid', $(columnId).data('tap-listen1'));

          if (typeof $(columnId).data('orig_tap_callid') === 'undefined') {
            $(columnId).data('orig_tap_callid', $(columnId).data('tap-listen2'));
          }
        }
      }

      if (allowWisper) {
        log('allowing wisper');
      } else {
        log('no wisper');
      }

      if (!allowWisper) {
        $(monitorActionsOrig).hide();
        $(monitorActionsTerm).hide();
      } else if ($(columnId).data('monitor-mode') != 'barge') {
        $(monitorActionsOrig).show();
        $(monitorActionsTerm).show();
      }

      url = '/portal/calls/getCallById/' + $(columnId).data('tap_callid') + '/term_callid';

      if (!$(columnId).data('lookedupalready')) {
        $.getJSON(
          url,
          function (data) {
            log('data retruned. ');
            log(data);

            if (allowWisper) {
              $(columnId).data('lookedupalready', true);
            }

            if (!allowWisper) {
              $(monitorActionsOrig).hide();
              $(monitorActionsTerm).hide();
            } else {
              $(monitorActionsOrig).show();
              $(monitorActionsTerm).show();
            }

            $.each(data, function (key, val) {
              log('key=' + key);

              if (key == 'orig_match') {
                var containsStar = false;

                if (val.indexOf('*') > -1) {
                  containsStar = true;
                }

                log('allowWisper=' + allowWisper);
                log(key + '=' + val);
                log(key + '=' + cleanDevice(val).length);
                log('containsStar=' + containsStar);

                if (containsStar && typeof data.orig_uri !== 'undefined') {
                  val = data.orig_uri;
                }

                if (allowWisper && cleanDevice(val).length < 7 && !containsStar) {
                  $(monitorActionsOrig).text(_('Whisper to ') + cleanDevice(val));
                  $(monitorActionsOrig).data('devicename', cleanDevice(val));
                } else if (allowWisper) {
                  log('REMOVING ORIG');
                  log(data);
                  $(monitorActionsOrig).remove();
                }

                $(origNumber).html(cleanDevice(val));
              } else if (key == 'term_uri') {
                log(key + '=' + val);
                log(key + '=' + cleanDevice(val).length);

                if (allowWisper && cleanDevice(val).length < 7) {
                  $(monitorActionsTerm).text(_('Whisper to ') + cleanDevice(val));
                  $(monitorActionsTerm).data('devicename', cleanDevice(val));
                } else if (allowWisper) {
                  log('REMOVING TERM');
                  log(data);
                  $(monitorActionsTerm).remove();
                }

                $(termNumber).html(cleanDevice(val));
              } else if (key == 'orig_name') {
                $(origName).html(val);
              }
            });

            $(monitorActionsBarge).off('click');
            $(monitorActionsBarge).on('click', function () {
              $(columnId).data('monitor-mode', 'barge');
              jsFlash(_('Joining Call...'), 'info');

              url = '/portal/calls/barge_in/' + escapeCallid($(columnId).data('orig_tap_callid'));

              $.post(url, $.noop)
                .fail(console.error)
                .done($.noop);

              url = '/portal/calls/barge_in/' + escapeCallid($(columnId).data('term_tap_callid'));

              $.post(url, $.noop)
                .fail(console.error)
                .done($.noop);

              $(monitorActionsBarge).hide();
              $(monitorActionsOrig).hide();
              $(monitorActionsTerm).hide();
              $(monitorActionsListen).show();
            });
            $(monitorActionsOrig).off('click');
            $(monitorActionsOrig).on('click', function () {
              $(columnId).data('monitor-mode', 'wisper');

              url = '/portal/calls/barge_in/' + escapeCallid($(columnId)
                .data('orig_tap_callid'));

              log(url);
              $.post(url, $.noop)
                .fail(console.error)
                .done(function () {
                  jsFlash(String.format(
                    _('Whispering to {0}'),
                    $(monitorActionsOrig).data('devicename'),
                  ), 'info');
                });

              $(monitorActionsOrig).hide();
              $(monitorActionsTerm).hide();
              $(monitorActionsListen).show();
            });

            $(monitorActionsTerm).off('click');

            $(monitorActionsTerm).on('click', function () {
              $(columnId).data('monitor-mode', 'wisper');

              url = '/portal/calls/barge_in/' + escapeCallid($(columnId)
                .data('term_tap_callid'));

              log(url);
              $.post(url, $.noop)
                .fail(console.error)
                .done(function () {
                  jsFlash(String.format(
                    _('Whispering to {0}'),
                    $(monitorActionsTerm).data('devicename'),
                  ), 'info');
                });

              $(monitorActionsOrig).hide();
              $(monitorActionsTerm).hide();
              $(monitorActionsListen).show();
            });

            $(monitorActionsListen).off('click');
            $(monitorActionsListen).on('click', function () {
              $(columnId).data('monitor-mode', 'listen');

              url = '/portal/calls/listen/' + escapeCallid($(columnId).data('orig_tap_callid'));

              log(url);
              $.post(url, $.noop)
                .fail(console.error)
                .done($.noop);

              url = '/portal/calls/listen/' + escapeCallid($(columnId).data('term_tap_callid'));

              log(url);
              $.post(url, $.noop)
                .fail(console.error)
                .done(function () {
                  jsFlash(_('Listening only...'), 'info');
                });
              $(monitorActionsBarge).show();

              if (allowWisper) {
                $(monitorActionsOrig).show();
                $(monitorActionsTerm).show();
              }

              $(monitorActionsListen).hide();
            });

            $(dockBody)
              .find('div.loading-lg')
              .remove();
            $(callMonitor).show();
          },
        )
          .done(function () {
            if (!allowWisper) {
              $(monitorActionsOrig).hide();
              $(monitorActionsTerm).hide();
            }
          });
      }
    }
  } else if (value.time_answer != '0000-00-00 00:00:00') {
    // stop incoming call flashing animation
    $(dockBody)
      .animate({ backgroundColor: '#fff' })
      .stop();

    // remove incoming call info
    $(panelContent + ' h4').remove();
    $(panelContent + ' h3').remove();

    if (typeof portalAgentScreenPopUrl !== 'undefined' && portalAgentScreenPopUrl != '') {
      if (callType == 'inbound' && $(dockBody).data('popup') != true) {
        if (typeof number !== 'undefined' && number.length > 9) {
          var cookie = Cookies.get('popup' + $(columnId).data('term_callid'));

          if (cookie == null) {
            var date = moment().add(2, 'hours');

            Cookies.set('popup' + $(columnId).data('term_callid'), 'true', { expires: date.unix() });

            url = portalAgentScreenPopUrl + cleanDevicePrep(number);
            log(url);

            var newwindow = window.open(url, '_blank');

            if (newwindow && typeof newwindow !== 'undefined') {
              newwindow.focus();
              $(dockBody).data('popup', true);
            }
          }
        }
      }
    }

    if ($(panelInfo).length == 0) {
      if (recordCallButton) {
        $(panelContent).prepend(
          '<div class="dockcall-info">'
          + '<h5 class="dockcall-name extra-call-buttons">'
          + '<button class="btn btn-default record dockcall-record" data-toggle="button"'
          + ' title="Record Call"><i class="record"></i></button>'
          + '<span class="dockcall-callerid pull-right">'
          + number
          + '</span>'
          + '<span data-gmt-answer="' + value.time_answer
          + '" class="dockcall-timer duration_counter pull-right">00:00</span>'
          + '</h5>'
          + '</div>',
        );
      } else {
        $(panelContent).prepend(
          '<div class="dockcall-info">'
          + '<h5 class="dockcall-name">'
          + '<span class="dockcall-callerid">'
          + number
          + '</span>'
          + '<span data-gmt-answer="'
          + value.time_answer
          + '" class="dockcall-timer duration_counter pull-right">00:00</span>'
          + '</h5>'
          + '</div>',
        );
      }
    }

    if (value.by_action == 'QueueDispatch'
      || value.by_action == 'QueueSDispatch'
      || value.by_action == 'ForwardSRing'
      || value.by_action == 'MoveTo'
      || value.by_action == ''
    ) {
      log('QueueDispatch');

      if (popupShowNotes) {
        $(notes).show();

        if (dispositionList.inbound != null) {
          var inboundDispositions = dispositionList.inbound || null;

          if (!$(disposition).is(':visible')) {
            log('disposition not visible (googd)');

            if (callType === 'inbound') {
              $(disposition).empty()
                .hide();
              log('inbound match');

              if (inboundDispositions) {
                $(disposition)
                  .append($('<option />').val('')
                    .text(_('Select a Disposition')));

                log('inboundDispositions match');

                Object.keys(inboundDispositions).forEach(function (dispKey) {
                  $(disposition)
                    .append($('<option />').val(dispKey)
                      .text(dispKey))
                    .show();
                });
              }
            } else if (callType === 'outbound') {
              $(disposition)
                .empty()
                .hide();

              if (dispositionList.outbound != null) {
                var outboundDispositions = dispositionList.outbound;

                Object.keys(outboundDispositions).forEach(function (dispKey) {
                  $(disposition)
                    .append(
                      $('<option />')
                        .val(dispKey)
                        .text(dispKey),
                    )
                    .show();
                });
              }
            }
          }

          $(reason).empty();

          if (typeof $(disposition).val() !== 'undefined'
            && $(disposition).val() != null
            && $(disposition).val() !== ''
          ) {
            var dispString = $(disposition).val();
            var filteredList;

            if (callType === 'inbound') {
              filteredList = dispositionList.inbound[dispString];
            } else {
              filteredList = dispositionList.outbound[dispString];
            }

            if (filteredList != null) {
              $(reason).append(
                $('<option />')
                  .val('')
                  .text(_('Select a Disposition First')),
              );

              Object.keys(filteredList).forEach(function (dispKey) {
                $(reason)
                  .append(
                    $('<option />')
                      .val(filteredList[dispKey])
                      .text(filteredList[dispKey]),
                  )
                  .show();
              });
            } else {
              $(reason).hide();
            }
          }
        }
      }
    }

    if (user !== '*') {
      $(disposition).on('change', function () {
        $(reason).empty();

        if (typeof $(this).val() !== 'undefined' && $(this).val() !== '') {
          var reasons = [];
          var value = $(this).val().replace(/ /g, '').replace(/\//g, '').replace(/-/g, '');

          if (callType === 'inbound' && dispositionList.inbound != null) {
            reasons = dispositionList.inbound[value] || [];
          } else if (callType === 'outbound' && dispositionList.outbound != null) {
            reasons = dispositionList.outbound[value] || [];
          }

          if (reasons.length) {
            $(reason)
              .append(
                $('<option/>')
                  .val('')
                  .text(_('Select a Reason')),
              );

            for (var i = 0; i < reasons.length; i += 1) {
              $(reason)
                .append(
                  $('<option/>')
                    .val(reasons[i])
                    .text(reasons[i]),
                );

              $(reason).slideDown();
            }
          } else {
            $(reason).slideUp();
          }
        } else {
          $(reason).slideUp();
        }
      });
    }

    $(recordBtn).off();

    $(recordBtn).on('click', function () {
      if ($(recordBtn).data('recording')) {
        $(recordBtn).data('recording', false);
      } else {
        $(recordBtn).data('recording', true);
      }

      url = '/portal/calls/';

      if ($(recordBtn).data('recording')) {
        url += 'record_on/';
      } else {
        url += 'record_off/';
      }

      if (callType == 'outbound') {
        url += escapeCallid(value.term_callid);
      } else {
        url += escapeCallid(value.orig_callid);
      }

      log(url);

      $.post(url, $.noop)
        .fail(function () {
          if ($(recordBtn).data('recording')) {
            jsFlash(_('Call recording failed to start!'), 'danger');
            $(recordBtn).data('recording', false);
            $(recordBtn).removeClass('active');
          } else {
            jsFlash(_('Call recording failed to stop!'), 'danger');
            $(recordBtn).data('recording', true);
            $(recordBtn).addClass('active');
          }
        })
        .done(function () {
          if ($(recordBtn).data('recording')) {
            jsFlash(_('Call recording has started'), 'success');
          } else {
            jsFlash(_('Call recording has stopped'), 'success');
          }
        });
    });

    if ($(notes).val() == '') {
      $(notes).val(Cookies.get('notes' + thisId));
    }

    if (popupShowNotes) {
      $(notes).show();
    }

    $(notes).on('keypress', function () {
      // copy of this object for further usage
      var el = this;

      if (timeoutReference) {
        clearTimeout(timeoutReference);
      }

      timeoutReference = setTimeout(function () {
        updateNotes.call(el, thisId);
      }, 1000);
    });

    $(notes).on('blur', function () {
      updateNotes.call(this, thisId);
    });

    // generate call control buttons
    $(callButtons).html(
      '<div class="btn-group dockcall-callactions">'
      + '<button class="dockcall-hold btn" data-toggle="button" title="'
      + _('Hold')
      + '">'
      + '<i class="hold"></i>'
      + '</button>'
      + '<button class="dockcall-end btn btn-danger" title="'
      + _('End')
      + '">'
      + '<i class="end"></i>'
      + '</button>'
      + '<button class="dockcall-transfer btn" data-toggle="button" title="'
      + _('Transfer')
      + '">'
      + '<i class="transfer"></i>'
      + '</button>'
      + '</div>'
      + '<div class="transfer-field input-group hidden">'
      + '<input id="transfer-autocomplete" class="col-md-2" type="text"'
      + ' placeholder="Enter extension or number">'
      + '<button id="transfer'
      + thisId
      + '" type="button" class="btn btn-success" disabled>'
      + '<i class="glyphicon glyphicon-arrow-right"></i>'
      + '</button></div>',
    );

    // show transfer field when transfer button is clicked
    $(transButton).on('click', function () {
      if ($(callButtons + ' .transfer-field').is(':visible')) {
        closeTransferMode();

        $(callButtons + ' .transfer-field').animate({ height: 'hide', opacity: 'hide' }, 400);
      } else {
        initTransferMode(value);

        $(callButtons + ' .transfer-field')
          .animate({ height: 'show', opacity: 'show' }, 400);
      }
    });

    $('#transfer-autocomplete').on('focus', function () {
      if (typeof addAutoCompleteTransfer !== 'undefined') {
        addAutoCompleteTransfer();
      }
    });

    $('#transfer-autocomplete').on('keyup', function () {
      if ($(this).val() != '') {
        $('#transfer' + thisId).prop('disabled', false);
      } else {
        $('#transfer' + thisId).prop('disabled', true);
      }
    });

    $('#transfer' + thisId).on('click', function () {
      var dest = $('#transfer-autocomplete').val() + '';
      var destArray = dest.split(' ');

      ignoreOrigId.push(value.orig_callid);
      ignoreOrigId.push(value.term_callid);

      url = '/portal/calls/xfer/';

      $('#transfer' + thisId).prop('disabled', true);

      if (callType == 'outbound') {
        url = url + escapeCallid(value.term_callid) + '/' + destArray[0];
      } else {
        url = url + escapeCallid(value.orig_callid) + '/' + destArray[0];
      }

      $.post(url, $.noop)
        .fail(console.error)
        .done(function () {
          jsFlash(
            String.format(_('Transferring call to {0}'), $('#transfer-autocomplete').val()),
            'success',
          );

          closeTransferMode();

          $(columnId).remove();
        });
    });

    $(document).on('click', endButton, function () {
      $.post('/portal/calls/terminate/' + escapeCallid(value.term_callid))
        .fail(console.error);

      ignoreOrigId.push(value.orig_callid);

      $(endButton).prop('disabled', true);

      if (typeof holdButton !== 'undefined') {
        $(holdButton).prop('disabled', true);
      }

      if (typeof transButton !== 'undefined') {
        $(transButton).prop('disabled', true);
      }
    });
  } else if (value.by_action == 'ForwardSRing') {
    // Still ringing....
    var termDevices = $(columnId).data('termDevices');

    if (value.term_domain == value.term_to_uri.substring(value.term_to_uri.indexOf('@') + 1)) {
      if ($.inArray(value.term_to_uri, termDevices) === -1) {
        termDevices.push(value.term_to_uri);
      }
    }

    $(columnId).data('termDevices', termDevices);

    if (termDevices.length > 1) {
      $(answerButton).prop('disabled', true);
      $(answerButton).attr('title', 'Disabled on Sim Ring');
    }
  }
}

function popoutModifyCallsameURI(popup, value, domain, user) {
  var thisId = popup.attr('id');
  var popupId = '#' + thisId;

  log('popoutModifyCallsameURI: popupId  ' + popupId);

  var dockBody = popupId + ' .popcall-body';
  var callButtons = popupId + ' .popcall-buttons';
  var answerButton = popupId + ' .popcall-answer';
  var panelContent = popupId + ' .popcall-panel-content';
  var panelInfo = popupId + ' .popcall-info';
  var transButton = popupId + ' .popcall-transfer';
  var calltype = getType(value, domain, user);
  var number = getNumber(value, domain, user);
  var name = getName(value, domain, user, number);

  /** @type {array} */
  var termIds = popup.data('termIds');
  var termid = value.term_callid.replace(/[^a-zA-Z0-9]/g, '-');
  var termIdFound = false;

  termIds.forEach(function (val) {
    if (val == termid) {
      termIdFound = true;
    }
  });

  $(popupId).data('term_callid', value.term_callid);

  if (!termIdFound && typeof termIds.push === 'function') {
    termIds.push(termid);
  }

  var curLegCount = parseInt($(popupId).data('legCount'), 10);

  log('curLegCount=' + curLegCount);

  if (calltype == 'monitor') {
    // do nothing...
  } else if (value.time_answer != '0000-00-00 00:00:00') {
    log('should be answering: thisId  ' + thisId);

    // stop incoming call flashing animation
    $(dockBody)
      .animate({ backgroundColor: '#fff' })
      .stop();

    if ($(panelContent + ' .popcall-number').length == 0) {
      // replace inbound/outbound call message
      $(panelContent + ' h3').remove();
      $(panelContent + ' h4').html(name)
        .after('<h4 class="popcall-number">' + number + '</h4>');
    } else {
      $(panelContent + ' h4').html(name);
      $(panelContent + ' .popcall-number').text(number);
    }

    if ($(panelInfo).length == 0) {
      $(panelContent).prepend(
        '<div class="popcall-info">'
        + '<h5>Active Call <span class="popcall-onhold label label-danger hidden">'
        + _('On Hold')
        + '</span><span data-gmt-answer="' + value.time_answer + '"'
        + ' class="popcall-timer duration_counter pull-right">00:00</span>'
        + '</h5>'
        + '</div>',
      );
    }

    if ($(callButtons + ' .popcall-callactions').length == 0) {
      // generate call control buttons
      $(callButtons).html(
        '<div class="btn-group popcall-callactions">'
        + '<button class="btn btn-default popcall-hold" data-toggle="button" title="' + _('Hold') + '">'
        + '<i class="hold"></i>'
        + '</button>'
        + '<button class="btn btn-danger popcall-end" title="' + _('End') + '">'
        + '<i class="end"></i>'
        + '</button>'
        + '<button class="btn btn-default popcall-transfer" data-toggle="button"'
        + ' title="' + _('Transfer') + '">'
        + '<i class="transfer"></i>'
        + '</button>'
        + '</div>'
        + '<div class="transfer-field input-group hidden">'
        + '<input id="transfer-autocomplete" class="col-md-2" type="text"'
        + ' placeholder="Enter extension or number">'
        + '<button id="transfer' + thisId + '" type="button" class="btn btn-success" disabled>'
        + '<i class="glyphicon glyphicon-arrow-right"></i></button></div>',
      );
    }

    // resize scrollable content to fit with new call popup
    resizePopoutContent();

    // show transfer field when transfer button is clicked
    $(transButton).off()
      .on('click', function () {
        if ($(callButtons + ' .transfer-field').is(':visible')) {
          closeTransferMode();

          $(callButtons + ' .transfer-field').animate(
            { height: 'hide', opacity: 'hide' },
            {
              progress: function () {
                resizePopoutContent();
              },
            },
          );
        } else {
          initTransferMode(value);

          $(callButtons + ' .transfer-field').animate(
            { height: 'show', opacity: 'show' },
            {
              progress: function () {
                resizePopoutContent();
              },
            },
          );
        }
      });

    $('#transfer-autocomplete').on('focus', function () {
      if (typeof addAutoCompleteTransfer !== 'undefined') {
        addAutoCompleteTransfer();
      }
    });

    $('#transfer-autocomplete').on('keyup', function () {
      if ($(this).val() != '') {
        $('#transfer' + thisId).prop('disabled', false);
      } else {
        $('#transfer' + thisId).prop('disabled', true);
      }
    });

    $('#transfer' + thisId).on('click', function () {
      var dest = $('#transfer-autocomplete').val() + '';
      var destArray = dest.split(' ');

      ignoreOrigId.push(value.orig_callid);
      ignoreOrigId.push(value.term_callid);

      var url = '/portal/calls/xfer/';

      $('#transfer' + thisId).prop('disabled', true);

      if (calltype == 'outbound') {
        url = url + value.term_callid + '/' + destArray[0];
      } else {
        url = url + value.orig_callid + '/' + destArray[0];
      }

      $.post(url, $.noop)
        .fail(console.error)
        .done(function () {
          jsFlash(String.format(
            _('Transferring call to {0}'),
            $('#transfer-autocomplete').val(),
          ));

          $(callButtons + ' .transfer-field').animate({ height: 'hide', opacity: 'hide' }, 400);
          $(popupId).remove();

          resizePopoutContent();
        });
    });
  } else if (value.by_action == 'ForwardSRing') {
    // Still ringing....
    var termDevices = $(popupId).data('termDevices');

    if (value.term_domain == value.term_to_uri.substring(value.term_to_uri.indexOf('@') + 1)) {
      if ($.inArray(value.term_to_uri, termDevices) === -1) {
        termDevices.push(value.term_to_uri);
      }
    }

    $(popupId).data('termDevices', termDevices);

    if (termDevices.length > 1) {
      $(answerButton).prop('disabled', true);
      $(answerButton).attr('title', 'Disabled on Sim Ring');
    }
  }
}

function dockShowCall(value, domain, user) {
  console.log('dockShowCall');
  console.log('adding active call block');
  console.log(value);

  var callId = getCallKey(value);
  var columnId = '#dockcall-column-' + callId;
  var dockPopup = columnId + ' .dock-popup';
  var dockBody = columnId + ' .dockcall-body';
  var answerButton = columnId + ' .dockcall-answer';
  var callButtons = columnId + ' .dockcall-buttons';
  var holdButton = columnId + ' .dockcall-hold';
  var holdLabel = columnId + ' .dockcall-onhold';
  var endButton = columnId + ' .dockcall-end';
  var rejectButton = columnId + ' .dockcall-reject';
  var transButton = columnId + ' .dockcall-transfer';
  var completeButton = columnId + ' .dockcall-complete';
  var calltype = getType(value, domain, user);
  var number = getNumber(value, domain, user);
  var name = getName(value, domain, user, number);

  // if the orig_callid string doesn't contain 'CallToTalk' string but its from the
  // "Call-To-Talk app, then return out for the first call(s) executing dockShowCall
  // BUT show the active call popup when this string contains
  // 'CallToTalk' -> its the actual active call
  var hasString = value.orig_callid.indexOf('CallToTalk') !== -1;

  if (value.orig_from_user == 'Call-To-Talk' && hasString === false) {
    log('not showing dockcall because of Call-To-Talk');

    return;
  }

  var hasVideoBridge = value.term_to_uri.indexOf('video.bridge') !== -1;

  if (hasVideoBridge) {
    log('video bridge!, ignoring');

    return;
  }

  if (value.orig_from_user == 'CallPlayAccount' || value.orig_from_user == 'Call-Play-Account') {
    log('not showing dockcall because of CallPlayAccount');

    return;
  }

  if (value.orig_from_user == 'PromptRetrieve' || value.orig_from_user == 'PromptRetrieve') {
    log('not showing dockcall because of PromptRetrieve');

    return;
  }

  if (name == 'PromptRetrieve' || name == 'PromptRetrieve') {
    log('not showing dockcall because of PromptRetrieve');

    return;
  }

  if (number == 'PromptRetrieve' || number == 'PromptRetrieve') {
    log('not showing dockcall because of PromptRetrieve');

    return;
  }

  if (value.orig_to_user.startsWith('X') && value.orig_sub == subUser) {
    log('not showing dockcall because of of transfer completion');

    return;
  }

  if (value.orig_to_user.startsWith('X')
    && value.by_sub == subUser
    && value.term_sub != subUser
  ) {
    log('not showing dockcall because of of transfer completion');

    return;
  }

  if (value.term_to_uri == 'VMail' && subUser == value.term_sub) {
    ignoreOrigId.push(value.orig_callid);
    log('not showing dockcall because of VMail');

    return;
  }

  if (value.term_match.indexOf('w@') !== -1 && value.orig_match.indexOf('w@') !== -1) {
    if (value.media == 'VP8'
      || value.media == 'H264'
      || value.media == 'H265'
      || value.media == 'VP9'
    ) {
      log('not showing dockcall because of w@ and video codec');

      return;
    }
  }

  if (value.term_match.indexOf('vb@') !== -1 && value.orig_match.indexOf('vb@') !== -1) {
    if (value.media == 'VP8'
      || value.media == 'H264'
      || value.media == 'H265'
      || value.media == 'VP9'
    ) {
      log('not showing dockcall because of vb@ and video codec');

      return;
    }
  }

  if (value.term_match.indexOf('sip:data') !== -1 && value.orig_match.indexOf('sip:data') !== -1) {
    log('not showing dockcall because of sip:data');
    ignoreOrigId.push(value.orig_callid);

    return;
  }

  if (calltype == 'inbound') {
    if (value.term_match.indexOf('wp@') !== -1) {
      log('not showing dockcall because of wp@');

      return;
    }

    if (value.term_match.indexOf('sip:data') !== -1) {
      log('not showing dockcall because of sip:data');
      ignoreOrigId.push(value.orig_callid);

      return;
    }

    if (value.term_match.indexOf('vb@') !== -1) {
      log('not showing dockcall because of w@');
      ignoreTermId.push(value.term_callid);

      return;
    }

    if (value.term_match.indexOf('conference-bridge') !== -1) {
      if (hideInboundConferencePopups) {
        log('not showing dockcall because of conference-bridge');
        ignoreOrigId.push(value.orig_callid);

        return;
      }
    }
  } else {
    if (value.orig_match.indexOf('wp@') !== -1) {
      log('not showing dockcall because of wp@');
      ignoreOrigId.push(value.orig_callid);

      return;
    }

    if (value.orig_match.indexOf('vb@') !== -1) {
      log('not showing dockcall because of vb@');
      ignoreOrigId.push(value.orig_callid);

      return;
    }

    if (value.orig_match.indexOf('conference-bridge') !== -1) {
      if (hideInboundConferencePopups) {
        log('not showing dockcall because of conference-bridge');
        ignoreOrigId.push(value.orig_callid);

        return;
      }
    }
  }

  var popupHtml = `<div id="dockcall-${callId}"
     orig_callid="${value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')}"
     term_callid="${value.term_callid.replace(/[^a-zA-Z0-9]/g, '-')}"
     class="dockcall-panel">`;

  if (calltype == 'monitor') {
    popupHtml += '<div class="dockcall-panel-content"><h3 class="dockcall-number"></h3>';
    number = '&nbsp;';
    name = '&nbsp;';
  } else if (calltype == 'inbound') {
    popupHtml += `<div class="dockcall-panel-content">
    <h4>${_('Incoming Call')}</h4>
    <h3 class="dockcall-number">${number}</h3>`;
  } else {
    popupHtml += `<div class="dockcall-panel-content">
    <h4>${_('Outbound Call')}</h4>
    <h3 class="dockcall-number">${number}</h3>`;
  }

  if (calltype == 'monitor') {
    popupHtml += `<div class="loading-lg"></div>
<div class="dockcall-monitor hidden">
    <h4 class="dockcall-orignumber">${number}</h4>
    <h5 class="dockcall-origname">${number}</h5>
    <h4>+</h4><h4 class="dockcall-termnumber">${number}</h4>
    <button class="btn btn-default barge-btn" value="barge_in">${_('Join Call')}</button>
    <button class="btn btn-default hidden wisper-orig-btn" value="wisper_orig">${_('Whisper Orig')}</button>
    <button class="btn btn-default hidden wisper-term-btn" value="wisper_term">${_('Whisper Term')}</button>
    <button class="btn btn-default listen-btn hidden" value="listen">${_('Listen Only')}</button>`;
  } else {
    popupHtml += `<form action="/portal/callhistory/notes" id="dispForm">
    <div class="dockcall-fields">
        <select name="data[disposition]" class="form-control dockcall-disposition hidden" id="disposition">
            <option value="">${_('Disposition')}</option>
        </select>
        <select name="data[reason]" class="form-control dockcall-reason hidden" id="reason">
            <option value="">${_('Reason')}</option>
        </select>
        <textarea name="data[notes]"
                  class="form-control dockcall-notes hidden"
                  style="min-width: 98%;"
                  placeholder="${_('Notes')}"></textarea>
    </div>
</form>`;
  }

  popupHtml += '</div><div class="dockcall-buttons">';

  if (value.by_action == 'ForwardSRing') {
    popupHtml += `<h5 class="forward-select hidden">${_('Answer using:')}<select></select></h5> `;
  }

  if (calltype == 'monitor') {
    // TODO: add in monitor options
    name = _('Audio Monitoring');
  } else if (value.orig_from_user != 'Call-To-Talk' && calltype == 'inbound') {
    popupHtml += `<button class="dockcall-reject btn btn-danger"><i class="end"></i>Reject</button>
<button class="dockcall-answer btn btn-success"><i class="answer"></i>Answer</button>`;
  } else {
    popupHtml += `<button class="dockcall-end end-outbound btn btn-danger" title="${_('End')}">
    <i class="end"></i>
</button>`;
  }

  popupHtml += '</div></div>';

  var toPrepend = `<div id="dockcall-column-${callId}"
     class="dock-column dockcall-column"
     orig_callid="${value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')}"
     term_callid="${value.term_callid.replace(/[^a-zA-Z0-9]/g, '-')}">
    <div class="dock-column-inner">
        <div class="dock-popup">
            <div class="dock-head">
                <div class="dock-head-buttons">
                    <span class="dockcall-onhold label label-danger hidden">${_('On Hold')}</span>
                    <button class="dock-minimize dock-head-button" title="${_('Minimize')}">
                        <i class="glyphicon glyphicon-chevron-down" title="Minimize"></i>
                    </button>
                    <button class="dock-close dock-head-button" title="${_('Close')}">
                        <i class="glyphicon glyphicon-remove"></i>
                    </button>
                </div>
                <div class="dock-head-title">
                    <i class="fa fa-phone"></i> <span class="dock-name">${name}&nbsp;</span>
                </div>
            </div>
            <div class="dock-body dockcall-body">
                ${popupHtml}
            </div>
        </div>
    </div>
</div>`;

  // prepend dock html
  $('.dock-popup-overlay').prepend(toPrepend);

  var termIds = [value.term_callid.replace(/[^a-zA-Z0-9]/g, '-')];

  // adjust dock column height to show call popup
  dockHeight();

  setTimeout(function () {
    if ($(columnId + ' .dockcall-reject :visible').length) {
      ignoreTermId.push($(columnId).data('term_callid'));
      $(columnId).remove();
    }
  }, 60000);

  $(columnId).data('termIds', termIds);
  $(columnId).data('calltype', calltype);
  $(columnId).data('number', number);
  $(columnId).data('name', name);
  $(columnId).data('orig_callid', value.orig_callid);
  $(columnId).data('term_callid', value.term_callid);
  $(columnId).data('batch_tim_beg', value.time_start);

  if (value.by_action == 'ForwardSRing') {
    log('is sim ring');

    var termDevices = [];

    if (value.term_domain == value.term_to_uri.substring(value.term_to_uri.indexOf('@') + 1)) {
      if (!$.inArray(value.term_to_uri, termDevices)) {
        termDevices.push(value.term_to_uri);
      }
    }

    $(columnId).data('termDevices', termDevices);
  }

  if (calltype == 'monitor') {
    monitorIds.push(getMonitorId(value));
    $(columnId).data('monitor-id', getMonitorId(value));
    $(columnId).data('legCount', 0);
  }

  $(dockPopup).hide()
    .show(
      'slide',
      { direction: 'down' },
      500,
      function () {
        // function pulse() {
        //   // pulsate active call content for user attention
        //   $(dockBody).animate({
        //     backgroundColor: '#F3F781',
        //   }, 700, function () {
        //     $(this).animate({
        //       backgroundColor: '#fff',
        //     }, 700, pulse);
        //   });
        // }
        //
        // if (value.by_action != 'MoveTo' && value.time_answer == '0000-00-00 00:00:00') {
        //   if (calltype == 'inbound') {
        //     pulse();
        //   }
        // }
      },
    );

  // clicking answer stops pulse and shows button group
  $(document).on(
    'click',
    answerButton,
    function () {
      $(answerButton).prop('disabled', true);
      $(rejectButton).prop('disabled', true);

      var callID = value.term_callid;

      $.post('/portal/calls/answer/' + escapeCallid(callID) + '/' + cleanDevice(value.term_uri), $.noop)
        .fail(console.error);

      ignoreTermId.push(value.term_callid);
      intendedAnsOrigId.push(value.orig_callid);
    },
  );

  // show complete button after clicking end
  $(document).on('click', endButton, function () {
    $.post('/portal/calls/terminate/' + escapeCallid(value.term_callid))
      .fail(console.error);

    ignoreOrigId.push(value.orig_callid);

    $(endButton).prop('disabled', true);

    if (holdButton !== undefined) {
      $(holdButton).prop('disabled', true);
    }

    if (transButton !== undefined) {
      $(transButton).prop('disabled', true);
    }
  });

  $(document).on('click', rejectButton, function () {
    if (value.by_action == 'QueueSDispatch' || value.by_action == 'QueueSDispatch') {
      $.post(
        '/portal/calls/reject/' + value.orig_callid
        + '/' + value.term_to_uri.replace(':', 'COLLON'),
        function () {
          log('reject call');
        },
      )
        .fail(console.error);
    } else {
      $.post('/portal/calls/reject/' + value.orig_callid, $.noop)
        .fail(console.error);
    }

    $(answerButton).prop('disabled', true);
    $(rejectButton).prop('disabled', true);

    ignoreOrigId.push(value.orig_callid);

    // stop pulsing after clicking answer
    $(dockBody)
      .animate({ backgroundColor: '#fff' })
      .stop();

    $(callButtons).html('<button class="dockcall-complete btn btn-primary">Complete</button>');
    $(columnId).remove();
  });

  if (holdButton !== undefined) {
    // show hold label after clicking hold button
    $(document).on('click', holdButton, function () {
      if ($(holdLabel).is(':visible')) {
        $.post('/portal/calls/unhold/' + value.orig_callid, $.noop)
          .fail(console.error)
          .done(function () {
            $(holdLabel).hide();
          });
      } else if (calltype == 'inbound') {
        $.post('/portal/calls/hold_orig/' + value.orig_callid, $.noop)
          .fail(console.error)
          .done(function () {
            $(holdLabel).show();
          });
      } else {
        $.post('/portal/calls/hold_term/' + value.orig_callid, $.noop)
          .fail(console.error)
          .done(function () {
            $(holdLabel).show();
          });
      }
    });
  }

  // hide and remove call display after clicking complete
  $(document).on('click', completeButton, function () {
    sendDispostion(columnId);
    $(columnId).remove();

    ignoreOrigId.push(value.orig_callid);

    log(columnId.replace('#', ''));
    Cookies.remove('notes' + columnId.replace('#', ''));
  });

  if (value.time_answer != '0000-00-00 00:00:00') {
    dockModifyCallsameURI($(columnId), value, domain, user);
  }

  if (calltype == 'inbound' && portalHtml5Notifications) {
    notifyInbound(
      value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-'),
      name,
      cleanDevicePrep(number),
      number,
    );
  }
}

function popoutShowCall(value, domain, user) {
  log('popoutShowCall');
  log('adding active call block');
  log(value);

  var callId = getCallKey(value);

  var popupId = '#popcall-popup-' + callId;
  var popoutBody = popupId + ' .popcall-body';
  var answerButton = popupId + ' .popcall-answer';
  var holdButton = popupId + ' .popcall-hold';
  var holdLabel = popupId + ' .popcall-onhold';
  var endButton = popupId + ' .popcall-end';
  var rejectButton = popupId + ' .popcall-reject';
  var transButton = popupId + ' .popcall-transfer';
  var completeButton = popupId + ' .popcall-complete';
  var calltype = getType(value, domain, user);
  var number = getNumber(value, domain, user);
  var name = getName(value, domain, user, number);

  if (calltype == 'inbound') {
    if (value.term_match.indexOf('conference-bridge') !== -1) {
      if (hideInboundConferencePopups) {
        log('hiding popup because of hideInboundConferencePopups');
        ignoreOrigId.push(value.orig_callid);

        return;
      }
    }
  } else {
    log();

    if (value.orig_match.indexOf('conference-bridge') !== -1) {
      if (hideInboundConferencePopups) {
        log('hiding popup because of hideInboundConferencePopups');
        ignoreOrigId.push(value.orig_callid);

        return;
      }
    }
  }

  var popupHtml = '<div class="popcall-panel">';

  if (calltype == 'monitor') {
    popupHtml += '<div class="popcall-panel-content"><h3 class="popcall-number">';
    number = '&nbsp;';
    name = '&nbsp;';
  } else if (calltype == 'inbound') {
    popupHtml += `<div class="popcall-panel-content">
    <h4>Incoming Call</h4>
    <h3 class="popcall-number">${number}</h3>`;
  } else {
    popupHtml += `<div class="popcall-panel-content">
    <h4>Outbound Call</h4>
    <h3 class="popcall-number">${number}</h3>`;
  }

  if (calltype == 'monitor') {
    popupHtml += `<div class="loading-lg"></div>
<div class="popcall-monitor hidden">
    <h4 class="popcall-orignumber">${number}</h4>
    <h5 class="popcall-origname">${number}</h5>
    <h4>+</h4><h4 class="popcall-termnumber">${number}</h4>
    <button class="btn btn-default barge-btn" value="barge_in">${_('Join Call')}</button>
    <button class="btn btn-default hidden wisper-orig-btn" value="wisper_orig">${_('Whisper Orig')}</button>
    <button class="btn btn-default hidden wisper-term-btn" value="wisper_term">${_('Whisper Term')}</button>
    <button class="btn btn-default listen-btn hidden" value="listen">${_('Listen Only')}</button>`;
  } else {
    popupHtml += `<form action="/portal/callhistory/notes" id="dispForm">
    <div class="popcall-fields">
        <select name="data[disposition]"
                class="form-control popcall-disposition hidden"
                id="disposition">
            <option value="">Disposition</option>
        </select>
        <select name="data[reason]" class="form-control popcall-reason hidden" id="reason">
            <option value="">Reason</option>
        </select>
        <textarea name="data[notes]"
                  class="form-control popcall-notes hidden"
                  placeholder="${_('Notes')}"
                  style="min-width: 98%;"></textarea>
    </div>
</form>`;
  }

  popupHtml += '</div><div class="popcall-buttons">';

  if (value.by_action == 'ForwardSRing') {
    popupHtml += '<h5 class="forward-select hidden">Answer using: <select></select></h5> ';
  }

  if (calltype == 'monitor') {
    // TODO: add in monitor options
    name = _('Audio Monitoring');
  } else if (calltype == 'inbound') {
    popupHtml += `<button class="popcall-reject btn btn-danger"><i class="end"></i>Reject</button>
<button class="popcall-answer btn btn-success"><i class="answer"></i>Answer</button>`;
  } else {
    popupHtml += `<button class="popcall-end end-outbound btn btn-danger" title="${_('End')}"><i class="end"></i></button>`;
  }

  popupHtml += '</div></div>';

  var toPrepend = `<div id="popcall-popup-${callId}"
     class="popcall-popup hidden"
     orig_callid="${value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')}"
     term_callid="${value.term_callid.replace(/[^a-zA-Z0-9]/g, '-')}">
    <div class="popcall-body">${popupHtml}</div>
</div>`;

  // prepend popout html
  $('.popcall-container').prepend(toPrepend);

  var termIds = [value.term_callid.replace(/[^a-zA-Z0-9]/g, '-')];

  $(popupId).data('termIds', termIds);
  $(popupId).data('calltype', calltype);
  $(popupId).data('number', number);
  $(popupId).data('name', name);
  $(popupId).data('orig_callid', value.orig_callid);
  $(popupId).data('term_callid', value.term_callid);

  if (value.by_action == 'ForwardSRing') {
    log('is sim ring');

    var termDevices = [];

    if (value.term_domain == value.term_to_uri.substring(value.term_to_uri.indexOf('@') + 1)) {
      if (!$.inArray(value.term_to_uri, termDevices)) {
        termDevices.push(value.term_to_uri);
      }
    }

    $(popupId).data('termDevices', termDevices);
  }

  if (calltype == 'monitor') {
    monitorIds.push(getMonitorId(value));
    $(popupId).data('monitor-id', getMonitorId(value));
    $(popupId).data('legCount', 0);
  }

  // hide dialpad
  if ($('.popcall-container .dial-pad').is(':visible')) {
    $('.popcall-container .dial-pad').animate(
      { height: 'hide' },
      {
        complete: function () {
          $('.dial-pad').remove();
          $('#make-call').button('toggle');
        },
      },
    );
  }

  // reveal popout call section
  $(popupId).animate(
    { height: 'show' },
    {
      progress: function () {
        resizePopoutContent();
      },
      complete: function () {
        // function pulse() {
        //   // pulsate active call content for user attention
        //   $(popoutBody).animate({
        //     backgroundColor: '#F3F781',
        //   }, 700, function () {
        //     $(this).animate({
        //       backgroundColor: '#fff',
        //     }, 700, pulse);
        //   });
        // }
        //
        // if (value.by_action != 'MoveTo' && value.time_answer == '0000-00-00 00:00:00') {
        //   if (calltype == 'inbound') {
        //     pulse();
        //   }
        // }
      },
    },
  );

  // clicking answer stops pulse and shows button group
  $(document).on(
    'click',
    answerButton,
    function () {
      $(answerButton).prop('disabled', true);
      $(rejectButton).prop('disabled', true);

      var url = '/portal/calls/answer/'
        + escapeCallid(value.term_callid)
        + '/'
        + cleanDevice(value.term_uri);

      log('url is ' + url);

      $.post(url, $.noop)
        .fail(console.error)
        .done();

      ignoreTermId.push(value.term_callid);
      intendedAnsOrigId.push(value.orig_callid);
    },
  );

  // show complete button after clicking end
  $(document).on('click', endButton, function () {
    $.post('/portal/calls/terminate/' + escapeCallid(value.orig_callid))
      .fail(console.error);

    ignoreOrigId.push(value.orig_callid);

    if (endButton !== undefined) {
      $(endButton).prop('disabled', true);
    }

    if (holdButton !== undefined) {
      $(holdButton).prop('disabled', true);
    }

    if (transButton !== undefined) {
      $(transButton).prop('disabled', true);
    }
  });

  $(document).on('click', rejectButton, function () {
    if (value.by_action == 'QueueSDispatch' || value.by_action == 'QueueSDispatch') {
      $.post(
        '/portal/calls/reject/'
        + escapeCallid(value.orig_callid)
        + '/'
        + value.term_to_uri.replace(':', 'COLLON'),
        function () {
          log('reject call');
        },
      )
        .fail(console.error)
        .done();
    } else {
      $.post(
        '/portal/calls/reject/' + escapeCallid(value.orig_callid),
        function () {
          log('reject call');
        },
      )
        .fail(console.error)
        .done();
    }

    $(answerButton).prop('disabled', true);
    $(rejectButton).prop('disabled', true);

    ignoreOrigId.push(value.orig_callid);

    // stop pulsing after clicking answer
    $(popoutBody).animate({ backgroundColor: '#fff' })
      .stop();

    // remove inline styles added by .animate() to reset
    $('.popcall-container').removeAttr('style');

    // removes call popup completely
    $(popupId).remove();

    // resize content scrollable area
    resizePopoutContent();
    checkPopupWidth();
  });

  // show hold label after clicking hold button
  if (holdButton !== undefined) {
    $(document).on('click', holdButton, function () {
      if ($(holdLabel).is(':visible')) {
        $.post('/portal/calls/unhold/' + escapeCallid(value.orig_callid), $.noop)
          .fail(console.error)
          .done(function () {
            $(holdLabel).hide();
          });
      } else {
        log('should show hold label');

        if (calltype == 'inbound') {
          $.post('/portal/calls/hold_orig/' + escapeCallid(value.orig_callid), $.noop)
            .fail(console.error)
            .done(function () {
              $(holdLabel).show();
              log('should show hold label');
            });
        } else {
          $.post('/portal/calls/hold_term/' + escapeCallid(value.orig_callid), $.noop)
            .fail(console.error)
            .done(function () {
              $(holdLabel).show();
              log('should show hold label');
            });
        }
      }
    });
  }

  // hide and remove call display after clicking complete
  $(document).on('click', completeButton, function () {
    sendDispostion(popupId);
    $(popupId).remove();

    ignoreOrigId.push(value.orig_callid);

    // resize content scrollable area
    resizePopoutContent();
    checkPopupWidth();
  });

  if (value.time_answer != '0000-00-00 00:00:00') {
    popoutModifyCallsameURI($(popupId), value, domain, user);
  }
}

/**
 * generate the options html for the phone/devices select
 *
 * @param {object} devices is an object with all the user devices/phones
 * @returns {string} html is a string of html for the select options
 * */
function generateDeviceOptions(devices) {
  if (typeof devices === 'string') {
    devices = JSON.parse(devices);
  }

  var defaultDevice = lookupDefaultDevice();
  var html = '';

  if (isWebrtc && typeof SNAPmobileWebenabled !== 'undefined' && SNAPmobileWebenabled) {
    if (defaultDevice == 'webphone') {
      html += '<option selected value="webphone">' + SNAPmobileWebName + '</option>';
    } else {
      html += '<option value="webphone">' + SNAPmobileWebName + '</option>';
    }
  }

  devices.forEach(function (item) {
    var shouldContinue = true;

    if (typeof item === 'undefined'
      || typeof item.user_agent === 'undefined'
      || item.user_agent == ''
      || item.user_agent.includes('SNAPscreenShare')
      || item.user_agent.includes('SNAPdataChannel')
      || item.user_agent.includes('SNAPvideo')
      || item.aor.includes('conference-bridge')
      || item.aor.includes('wp@')
      || item.aor.includes('vb@')
    ) {
      shouldContinue = false;
    }

    if (shouldContinue) {
      var device = cleanDevicePrep(item.aor);

      if (defaultDevice == device) {
        html += '<option selected value="' + device + '">' + item.user_agent + '</option>';
      } else {
        html += '<option value="' + device + '">' + item.user_agent + '</option>';
      }
    }
  });

  html += '<option value="" >' + _('Enter Phone number') + '</option>';

  return html;
}

/**
 * generate the content for the confirm call popover
 *
 * @param {object} el is the popover trigger element
 * @param {object} devices is an object with all the user devices/phones
 * */
function generateDeviceOptionsPopoverContent(el, devices) {
  var num = $(el).data('number') ? $(el).data('number') : $(el).text();
  var contentTitle = '<h5>' + _('Call {0} using', num) + ':</h5>';
  var rand = Math.floor(Math.random() * 99999);
  var content;
  var deviceOptions = generateDeviceOptions(devices);
  var contentDrop;
  var contentText;
  var contentCheck;
  var contentTextReset;
  var isAuto = portalClickToCallUseAuto ? 'true' : 'false';

  if (deviceOptions.length) {
    contentDrop = `<p class="isCallDropbox">
    <select id="device-select-popover-${rand}"
            class="form-control device-select"
            onchange="uncheckDefaultDeviceBox('device-select-popover-${rand}-checkbox')">
        ${deviceOptions}
    </select>
</p>`;

    contentText = `<p class="isCallTextbox hidden">
    <input id="device-text-popover-${rand}" type="text" value="" placeholder="${_('Enter a phone number')}" />
</p>`;

    contentCheck = `<p class="isCallDropboxCheckbox">
    <input id="device-select-popover-${rand}-checkbox"
           type="checkbox"
           name="isDefault"
           class="click2callphonedefault"
           value="isDefault"
           checked /> <span class="text-muted table-smaller"> ${_('Use this phone by default')}<span>
</p>`;

    contentTextReset = `<p>
    <span id="changePhones"
          style="display: none"
          class="bluetext isnumberreset"
          onclick="setCustom(false)">${_('Choose another phone')}</span>
</p>`;
  } else {
    contentDrop = `<p class="isCallDropbox hidden">
    <select id="device-select-popover-${rand}"
            class="form-control device-select"
            onchange="uncheckDefaultDeviceBox('device-select-popover-${rand}-checkbox')">
        ${deviceOptions}
    </select>
</p>`;

    contentText = `<p class="isCallTextbox">
    <input id="device-text-popover-${rand}" type="text" value="" placeholder="${_('Enter a phone number')}" />
</p>`;

    contentCheck = `<p class="isCallDropboxCheckbox hidden">
    <input id="device-select-popover-${rand}-checkbox"
           type="checkbox"
           name="isDefault"
           class="click2callphonedefault"
           value="isDefault"
           checked /> <span class="text-muted table-smaller">${_('Use this phone by default')}<span>
</p>`;

    contentTextReset = `<p>
    <span id="changePhones" class="bluetext isnumberreset" onclick="setCustom(false)">${_('Choose another phone')}</span>
</p>`;
  }

  var contentBtn1 = `<button class="btn btn-primary btn-sm small"
        onclick="dialWithPhoneOption('device-select-popover-${rand}','${num}',${isAuto})"
        data-number="${num}">${_('Call')}
</button>`;

  var contentBtn2 = `<button class="btn btn-default btn-sm small" onclick="$('.make-call-options').popover('hide');">${_('Cancel')}</button>`;
  var contentBtns = `<p>${contentBtn1}${contentBtn2}</p>`;

  content = contentTitle
    + contentDrop
    + contentText
    + contentCheck
    + contentTextReset
    + contentBtns;

  return content;
}

/**
 * create and bind the confirm call popovers that have phone options
 *
 * @param {object} devices is an object with all the user devices/phones
 * */
function createConfirmCallPopover(devices) {
  if (typeof devices === 'string') {
    devices = JSON.parse(devices);
  }

  var triggerEvent = devices[0] != null || isWebrtc ? 'click' : 'hover';

  $('.make-call-options').each(function () {
    // remove 'call' tooltips if you can't call
    if (triggerEvent == 'hover') {
      $(this).removeClass('helpsy')
        .tooltip('destroy');
    }

    $(this).popover({
      trigger: triggerEvent,
      toggle: 'popover',
      placement: $(this).data('placement') ? $(this).data('placement') : 'right',
      container: 'body',
      html: true,
      sanitize: false,
      template: `<div class="popover call-options-popover" role="tooltip">
    <div class="arrow"></div>
    <div class="popover-content"></div>
</div>`,
      content: generateDeviceOptionsPopoverContent(this, devices),
      delay: {
        show: 200,
        hide: 0,
      },
    });
  });
}

function updateCallLineUser(value, domain, user) {
  var rId = getCallKey(value);
  var found = false;

  function refreshCalHistory() {
    callHistoryLookupScheduled = true;
    setTimeout(function () {
      callHistoryLookupScheduled = false;

      if ($('.modal').is(':visible') == true) {
        refreshCalHistory();
      } else if (typeof NsAgentsMain === 'function') {
        NsAgentsMain.homeCallHistory(true);
      }
    }, 2000);
  }

  function refreshVmails() {
    vMailLookupScheduled = true;

    setTimeout(function () {
      vMailLookupScheduled = false;

      if ($('.modal').is(':visible') == true) {
        refreshVmails();
        log('delaying vmail update do to modal');
      } else {
        log(value);

        if (value.term_to_uri == 'VMail') {
          log('is a vmail ending');

          if (typeof homeVoicemail === 'function') {
            log('running homeVoicemail');
            homeVoicemail();
          }

          if (typeof getCount === 'function') {
            log('running getCount');
            getCount();
          }
        }
      }
    }, 2000);
  }

  if (value.remove != 'yes') {
    log('user data');
    log(value);

    var calltype = getType(value, domain, user);
    var monitorId = 'notmonitored';

    if (calltype == 'monitor') {
      monitorId = getMonitorId(value);

      log('callid= ' + value.orig_callid);
      log('monitorId= ' + monitorId);
    } else if (typeof value.orig_logi_uri !== 'undefined'
      && typeof value.orig_from_name !== 'undefined'
    ) {
      if (value.orig_from_name == 'Bridge for Audio Monitoring'
        && value.orig_logi_uri.indexOf('adhoc.monitor') > -1
      ) {
        log('pontenital inbound for listen. silence popup. track callid. ');
        log(value.orig_logi_uri);

        if (value.time_answer != '0000-00-00 00:00:00') {
          audioMonitoringtoClearOnHangup.push(value.orig_logi_uri);
        }

        return;
      }
    }

    if (typeof value.ani !== 'undefined' && value.ani == 'Prompt-Callback-Retrieve') {
      callbackIds.push(value.by_callid);
    }

    $('.dockcall-column').each(function () {
      var thisId = $(this).attr('id');

      if ($(this).data('calltype') == 'monitor' && $(this).data('monitor-id') == monitorId) {
        dockModifyCallsameURI($(this), value, domain, user);

        found = true;
      } else if (thisId === 'dockcall-column-' + rId) {
        dockModifyCallsameURI($(this), value, domain, user);

        found = true;
      } else if ($(this).attr('orig_callid') == value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')) {
        var updateOk = true;

        intendedAnsOrigId.forEach(function (id, index) {
          if (id == value.orig_callid) {
            if (value.time_answer == '0000-00-00 00:00:00') {
              updateOk = false;
            } else {
              intendedAnsOrigId.splice(index, 1);
            }
          }
        });

        if (updateOk) {
          dockModifyCallsameURI($(this), value, domain, user);
        }

        found = true;
      }
    });

    if (!found) {
      console.log('calling dockShowCall possible type is ' + calltype);
      console.log('possible monitring id is  ' + monitorId);

      var foundInIgnore = false;

      ignoreOrigId.forEach(function (id) {
        if (id == value.orig_callid) {
          foundInIgnore = true;
        }
      });

      ignoreTermId.forEach(function (id) {
        if (id == value.term_callid && callbackIds.indexOf(value.term_callid) === -1) {
          foundInIgnore = true;
        }
      });

      if (value.ani == subUser && (value.term_to_uri == 'Monitoring' || value.term_to_uri.includes('adhoc.monitor'))) {
        foundInIgnore = true;
      }

      if (!foundInIgnore) {
        console.log(455);
        console.log('execute dockShowCall');
        dockShowCall(value, domain, user);
        checkPopupWidth();
      }
    }
  } else {
    // DELETE
    $('.dockcall-column').each(function () {
      for (var i = 0; i < audioMonitoringtoClearOnHangup.length; i += 1) {
        if (typeof $(this).data('confbridge_id') !== 'undefined') {
          if ($(this).data('confbridge_id') == audioMonitoringtoClearOnHangup[i]) {
            $(this).remove();
            checkPopupWidth();

            return;
          }
        }
      }
    });

    $('.dockcall-column').each(function () {
      var i;

      if ($(this).attr('orig_callid') == value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')) {
        for (i = 0; i < ignoreOrigId.length; i += 1) {
          if (ignoreOrigId[i] == $(this).attr('orig_callid')) {
            $(this).remove();
            checkPopupWidth();

            return;
          }
        }

        for (i = 0; i < ignoreTermId.length; i += 1) {
          if (ignoreTermId[i] == value.term_callid) {
            return;
          }
        }

        if ($(this).data('calltype') == 'monitor') {
          return;
        }

        var termIds = $(this).data('termIds');
        var termid = value.term_callid.replace(/[^a-zA-Z0-9]/g, '-');

        if (termid in termIds) {
          termIds.remove(termid);
          checkPopupWidth();
        }

        var number = cleanDevice(value.orig_user);
        var callId = $(this).attr('id');
        var columnId = '#' + callId;
        var dockBody = columnId + ' .dockcall-body';
        var callButtons = columnId + ' .dockcall-buttons';
        var callFields = columnId + ' .dockcall-fields';
        var durationField = columnId + ' .dockcall-timer';
        var disposition = columnId + ' .dockcall-disposition';
        var notes = columnId + ' .dockcall-notes';
        var panelContent = columnId + ' .dockcall-panel-content';
        var callInfo = columnId + ' .dockcall-info';
        var transferTest = columnId + ' .ui-autocomplete-input';

        log(transferTest);
        log($(transferTest).length);

        if ($(transferTest).length) {
          closeTransferMode();
        }

        if ($(this).data('calltype') != 'monitor') {
          $(dockBody)
            .animate({ backgroundColor: '#fff' })
            .stop();
        }

        $(durationField).attr('class', 'dockcall-timer pull-right');
        $(panelContent + ' h4').remove();
        $(panelContent + ' h3').remove();

        if ($(this).data('calltype') != 'monitor') {
          if ($(callInfo).length == 0) {
            $(panelContent).prepend(
              '<div class="dockcall-info">'
              + '<h5 class="dockcall-name">'
              + number
              + '<span data-gmt-answer="'
              + value.time_answer
              + '" class="dockcall-timer duration_counter pull-right">00:00</span>'
              + '</h5>'
              + '</div>',
            );
          }
        }

        if ($(this).data('calltype') != 'monitor') {
          $(callFields).animate({ height: 'show', opacity: 'show' }, 400);
        }

        log($(notes).val().length);
        log($(notes).text());

        if (($(this).data('calltype') != 'monitor' && popupAllowComplete)) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(disposition).is(':visible')) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(notes).is(':visible') && $(notes).val().length > 0) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(this).data('calltype') != 'monitor' && !popupAllowComplete) {
          $(this).remove();
          checkPopupWidth();
        }
      }
    });

    if (!callHistoryLookupScheduled) {
      refreshCalHistory();
    }

    if (!vMailLookupScheduled) {
      refreshVmails();
    }
  }

  var activeCalls = 0;

  myCalls = [];
  callToTransfer = {};

  $('.dockcall-column').each(function () {
    myCalls[activeCalls] = $(this).data();
    activeCalls += 1;
  });

  if (activeCalls == 0) {
    $('.activecallonly').hide();
  } else {
    $('.activecallonly').show();
  }

  log(myCalls);
}

function updateCallLineUserPopout(value, domain, user) {
  var rId = getCallKey(value);
  var found = false;

  if (value.remove != 'yes') {
    var calltype = getType(value, domain, user);
    var monitorId = 'notmonitored';

    if (calltype == 'monitor') {
      monitorId = getMonitorId(value);
    }

    log('in single user add/modify');

    $('.popcall-popup').each(function () {
      var thisId = $(this).attr('id');

      log('in scan  function (.popcall-popup), call type is ' + $(this).data('calltype'));
      log('in scan  function (.popcall-popup), thisId    is ' + thisId);
      log('in scan  function (.popcall-popup), comparing is popcall-popup-' + rId);

      if ($(this).data('calltype') == 'monitor' && $(this).data('monitor-id') == monitorId) {
        // Do nothing
      } else if (thisId == 'popcall-popup-' + rId) {
        log('in scan  function (.popcall-popup), thisId    is ' + thisId);
        popoutModifyCallsameURI($(this), value, domain, user);

        found = true;
      } else if ($(this).attr('orig_callid') == value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')) {
        var updateOk = true;

        intendedAnsOrigId.forEach(function (id, index) {
          if (id == value.orig_callid) {
            if (value.time_answer == '0000-00-00 00:00:00') {
              updateOk = false;
            } else {
              intendedAnsOrigId.splice(index, 1);
            }
          }
        });

        if (updateOk) {
          popoutModifyCallsameURI($(this), value, domain, user);
        }

        found = true;
      }
    });

    if (!found) {
      log('calling popup ShowCall possible type is ' + calltype);
      log('possible monitring id is  ' + monitorId);

      var foundInIgnore = false;

      ignoreOrigId.forEach(function (id) {
        if (id == value.orig_callid) {
          foundInIgnore = true;
        }
      });

      ignoreTermId.forEach(function (id) {
        if (id == value.term_callid) {
          foundInIgnore = true;
        }
      });

      if (!foundInIgnore) {
        popoutShowCall(value, domain, user);
      }
    }
  } else {
    // DELETE
    $('.popcall-popup').each(function () {
      var i;

      if ($(this).attr('orig_callid') == value.orig_callid.replace(/[^a-zA-Z0-9]/g, '-')) {
        for (i = 0; i < ignoreOrigId.length; i += 1) {
          if (ignoreOrigId[i] == $(this).attr('orig_callid')) {
            $(this).remove();
            checkPopupWidth();

            return;
          }
        }

        for (i = 0; i < ignoreTermId.length; i += 1) {
          if (ignoreTermId[i] == value.term_callid) {
            return;
          }
        }

        if ($(this).data('calltype') == 'monitor') {
          return;
        }

        var termIds = $(this).data('termIds');
        var termid = value.term_callid.replace(/[^a-zA-Z0-9]/g, '-');

        if (termid in termIds) {
          termIds.remove(termid);
          checkPopupWidth();
        }

        var number = cleanDevice(value.orig_user);
        var callId = $(this).attr('id');
        var popoutId = '#popcall-popup' + callId;
        var dockBody = popoutId + ' .popcall-body';
        var callButtons = popoutId + ' .popcall-buttons';
        var callFields = popoutId + ' .popcall-fields';
        var durationField = popoutId + ' .popcall-timer';
        var disposition = popoutId + ' .popcall-disposition';
        var notes = popoutId + ' .popcall-notes';
        var panelContent = popoutId + ' .popcall-panel-content';
        var callInfo = popoutId + ' .popcall-info';

        if ($(this).data('calltype') != 'monitor') {
          $(dockBody).animate({ backgroundColor: '#fff' })
            .stop();
        }

        $(durationField).attr('class', 'popcall-timer pull-right');
        $(panelContent + ' h4').remove();
        $(panelContent + ' h3').remove();

        if ($(this).data('calltype') != 'monitor') {
          if ($(callInfo).length == 0) {
            $(panelContent).prepend(
              '<div class="popcall-info">'
              + '<h5 class="popcall-name">'
              + number
              + '<span data-gmt-answer="'
              + value.time_answer
              + '" class="popcall-timer duration_counter pull-right">00:00</span>'
              + '</h5>'
              + '</div>',
            );
          }
        }

        if ($(this).data('calltype') != 'monitor') {
          $(callFields).animate({ height: 'show', opacity: 'show' }, 400);
        }

        if (($(this).data('calltype') != 'monitor' && popupAllowComplete)) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(disposition).is(':visible')) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(notes).is(':visible') && $(notes).val().length > 0) {
          $(callButtons)
            .html('<button class="dockcall-complete btn btn-primary">Complete</button>');
        } else if ($(this).data('calltype') != 'monitor' && !popupAllowComplete) {
          $(this).remove();
        }

        checkPopupWidth();
      }

      // resize content scrollable area
      resizePopoutContent();
    });
  }

  // adding myCalls array to updateCallLineUserPopout() to match
  // dock updateCallLineUser() for use in transfer method
  var activeCalls = 0;

  myCalls = [];
  callToTransfer = {};

  $('.popcall-popup').each(function () {
    myCalls[activeCalls] = $(this).data();
    activeCalls += 1;
  });

  if (activeCalls == 0) {
    $('.activecallonly').hide();
  } else {
    $('.activecallonly').show();
  }

  log(myCalls);
}

function startVideo(ext, sessionId, type, isScreen) {
  if (sessionId === undefined) {
    sessionId = null;
  }

  // send message over before starting video, for event type chat message
  if (!type) {
    type = 'start';
  }

  if (!isScreen) {
    isScreen = false;
  }

  var url;
  var windowOptions;
  var destArray = ext.split(',');

  // this is video meeting with just myself
  if (ext && ext == subUser) {
    if (type == 'start') {
      windowOptions = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=1200,height=900';
      url = `https://${currentServerName}/video/start`;

      window.open(url, '_blank', windowOptions);
    } else if (type == 'schedule') {
      windowOptions = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=1200,height=900';
      url = `https://${currentServerName}/video/${type}`;

      window.open(url, '_blank', windowOptions);
    }

    return;
  }

  // keep the scheduling, should just open schedule url
  url = `https://${currentServerName}/video/${type}`;

  if (ext && type == 'schedule') {
    url += `?users=${ext}`;
    windowOptions = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=1200,height=900';

    window.open(url, '_blank', windowOptions);

    return;
  }

  // take in placeholder of video session
  if (sessionId == 'xx') {
    sessionId = null;
  }

  if (sessionId == null) {
    // generate session_id else API will create an arbitrary one that might not match
    // existing session_id in portal cache message_sessions
    sessionId = generateSessionId(
      subDomain,
      null,
      `${subUser}@${subDomain}`,
      `${ext}@${subDomain}`,
      null,
      null,
      sessionId,
    );
  }

  let meetingId = '';

  // get the meeting ID
  var argsCreateMeeting1 = {
    obj: 'meeting',
    action: 'create',
    domain: subDomain,
    user: subUser,
    getId: 'yes',

  };

  netsapiens.api.post(argsCreateMeeting1, function (getIdRes) {
    var attendees = [];
    var getIdResObj = JSON.parse(getIdRes);

    meetingId = getIdResObj.id;

    attendees.push({
      name: subName,
      email: subEmail,
      role: 'host',
      uid: `${subUser}@${subDomain}`,
    });

    var createAttendee = {
      obj: 'meeting',
      action: 'create',
      format: 'json',
      domain: subDomain,
      user: subUser,
      id: meetingId,
      name: '',
      attendees: JSON.stringify(attendees),
    };

    netsapiens.api.post(createAttendee, function () {
      // send message for video invite
      var args = {
        obj: 'message',
        action: 'create',
        type: 'chat-video-invite',
        domain: subDomain,
        user: subUser,
        session_id: sessionId,
        message: meetingId, // doesn't actually appear anywhere, just placeholder
        destination: destArray,
      };

      netsapiens.api.post(args, function () {
        url = `https://${currentServerName}/video/?id=${meetingId}`;

        if (isScreen) {
          url += '&s=1&v=0';
        }

        windowOptions = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=1200,height=900';
        window.open(url, '_blank', windowOptions);
      });
    });
  });
}

function popupShowScreenshare(value, domain, user) {
  log('popupShowScreenshare');

  if (value != null) {
    log(value);
    log(value.getId());
    log(value.getRemoteFriendlyName());
    log(value.getRemoteUri());
  }

  var box = '<div id="screenshare-layout-' + user + '"'
    + ' class="dock-column" style="height: 507px; width:480px"> ';

  box += '     <div class="dock-column-inner" style="height: 507px; width:470px"> ';
  box += '     <div class="dock-popup chat-popup" style="display: block;"> ';
  box += '     <div class="dock-head">';
  box += '       <div class="dock-head-buttons"> ';
  box = box
    + '        <i class="dock-minimize glyphicon glyphicon-chevron-down" title="'
    + _('Minimize')
    + '"> ';
  box += '        </i><i class="dock-close glyphicon glyphicon-remove"></i></div> ';
  box += '         <div class="dock-head-title">';
  box = box
    + '          <i class="glyphicon glyphicon-picture"></i><span class="dock-name">'
    + user
    + '</span> ';
  box += '       </div>';
  box += '     </div> ';
  box += '     <div class="dock-body " style="background-color: rgb(255, 255, 255);"> ';
  box += '<div id="divCallCtrl" class="inDock">';
  box += '  </div> ';
  box += '';
  box += '</div> ';

  $('.dock-popup-overlay').prepend(box);

  $('.divCallCtrlHidden').clone(true, true)
    .appendTo('#screenshare-layout-' + user + ' .dock-body');

  $('.divBtnCallGroup').append(
    '<button id="btnFull" class="btn btn-primary"  onclick="toggleFullScreen();"'
    + ' value="Full Screen">Full Screen</button>',
  );

  dockHeight();

  $('#btnCall').on('click', function () {
    sipCall('answer');
  });

  $('#btnFullScreen').on('click', function () {
    toggleFullScreen();
  });

  dockHeight();
}

function popupShowScreenshare2(value, domain, user) {
  log('popupShowScreenshare');
  log(value);
  log(value.getId());
  log(value.getRemoteFriendlyName());
  log(value.getRemoteUri());

  var callId = value.getRemoteFriendlyName() + '_' + value.getId() + domain;
  var popupId = '#popcall-popup-' + callId;
  var popoutBody = popupId + ' .popcall-body';
  var answerButton = popupId + ' .popcall-answer';
  var holdButton = popupId + ' .popcall-hold';
  var holdLabel = popupId + ' .popcall-onhold';
  var endButton = popupId + ' .popcall-end';
  var rejectButton = popupId + ' .popcall-reject';
  var transButton = popupId + ' .popcall-transfer';
  var completeButton = popupId + ' .popcall-complete';
  var calltype = 'inbound';
  var number = user;
  var name = 'no name yet';
  var popupHtml = '<div class="popcall-panel">';

  if (calltype == 'monitor') {
    popupHtml += '<div class="popcall-panel-content"><h3 class="popcall-number">';
    number = '&nbsp;';
    name = '&nbsp;';
  } else if (calltype == 'inbound') {
    popupHtml += `<div class="popcall-panel-content">
    <h4>Incoming Call</h4>
    <h3 class="popcall-number">${number}</h3>`;
  } else {
    popupHtml += `<div class="popcall-panel-content">
    <h4>Outbound Call</h4>
    <h3 class="popcall-number">${number}</h3>`;
  }

  popupHtml += `<form action="/portal/callhistory/notes" id="dispForm">
    <div class="popcall-fields">
        <select name="data[disposition]" class="popcall-disposition hidden" id="disposition">
            <option value="">Disposition</option>
        </select>
        <select name="data[reason]" class="popcall-reason hidden" id="reason">
            <option value="">Reason</option>
        </select>
        <textarea name="data[notes]" class="popcall-notes hidden" placeholder="${_('Notes')}"></textarea>
    </div>
</form>`;

  popupHtml += '</div><div class="popcall-buttons">';

  if (calltype == 'inbound') {
    popupHtml += `<button class="popcall-reject btn btn-danger"><i class="end"></i>Reject</button>
<button class="popcall-answer btn btn-success"><i class="answer"></i>Answer</button>`;
  } else {
    popupHtml += `<button class="popcall-end end-outbound btn btn-danger" title="${_('End')}"><i class="end"></i></button>`;
  }

  popupHtml += '</div></div>';

  var toPrepend = `<div id="popcall-popup-${callId}" class="popcall-popup">
    <div class="popcall-body">${popupHtml}</div>
</div>`;

  // prepend popout html
  log(toPrepend);
  $('.popcall-container').prepend(toPrepend);

  $(popupId).data('calltype', calltype);
  $(popupId).data('number', number);
  $(popupId).data('name', name);

  // hide dialpad
  if ($('.popcall-container .dial-pad').is(':visible')) {
    $('.popcall-container .dial-pad').animate(
      { height: 'hide' },
      {
        complete: function () {
          $('.dial-pad').remove();
          $('#make-call').button('toggle');
        },
      },
    );
  }

  // reveal popout call section
  $(popupId).animate(
    { height: 'show' },
    { progress: resizePopoutContent },
  );

  // clicking answer stops pulse and shows button group
  $(document).on(
    'click',
    answerButton,
    function () {
      $(answerButton).prop('disabled', true);
      $(rejectButton).prop('disabled', true);

      $.post('/portal/calls/answer/' + escapeCallid(value.term_callid) + '/' + cleanDevice(value.term_uri), $.noop)
        .fail(console.error)
        .done();

      ignoreTermId.push(value.term_callid);
      intendedAnsOrigId.push(value.orig_callid);
    },
  );

  // show complete button after clicking end
  $(document).on('click', endButton, function () {
    $.post('/portal/calls/terminate/' + escapeCallid(value.orig_callid))
      .fail(console.error);

    ignoreOrigId.push(value.orig_callid);

    $(endButton).prop('disabled', true);

    if (holdButton !== undefined) {
      $(holdButton).prop('disabled', true);
    }

    if (transButton !== undefined) {
      $(transButton).prop('disabled', true);
    }
  });

  $(document).on('click', rejectButton, function () {
    if (value.by_action == 'QueueSDispatch' || value.by_action == 'QueueSDispatch') {
      $.post('/portal/calls/reject/'
        + escapeCallid(value.orig_callid)
        + '/'
        + value.term_to_uri.replace(':', 'COLLON'), function () {
        log('reject call');
      })
        .fail(console.error)
        .done();
    } else {
      $.post('/portal/calls/reject/' + escapeCallid(value.orig_callid), function () {
        log('reject call');
      })
        .fail(console.error)
        .done();
    }

    $(answerButton).prop('disabled', true);
    $(rejectButton).prop('disabled', true);

    ignoreOrigId.push(value.orig_callid);

    // stop pulsing after clicking answer
    $(popoutBody)
      .animate({ backgroundColor: '#fff' })
      .stop();

    // remove inline styles added by .animate() to reset
    $('.popcall-container').removeAttr('style');

    // removes call popup completely
    $(popupId).remove();

    // resize content scrollable area
    resizePopoutContent();
  });

  // show hold label after clicking hold button
  if (holdButton !== undefined) {
    $(document).on('click', holdButton, function () {
      if ($(holdLabel).is(':visible')) {
        $.post('/portal/calls/unhold/' + escapeCallid(value.orig_callid), $.noop)
          .fail(console.error)
          .done(function () {
            $(holdLabel).hide();
          });
      } else {
        log('should show hold label');

        if (calltype == 'inbound') {
          $.post('/portal/calls/hold_orig/' + escapeCallid(value.orig_callid), $.noop)
            .fail(console.error)
            .done(function () {
              $(holdLabel).show();
              log('should show hold label');
            });
        } else {
          $.post('/portal/calls/hold_term/' + escapeCallid(value.orig_callid), $.noop)
            .fail(console.error)
            .done(function () {
              $(holdLabel).show();
              log('should show hold label');
            });
        }
      }
    });
  }

  // hide and remove call display after clicking complete
  $(document).on('click', completeButton, function () {
    sendDispostion(popupId);
    $(popupId).remove();

    ignoreOrigId.push(value.orig_callid);

    // resize content scrollable area
    resizePopoutContent();
  });

  log('end popoutShowScreenshare function');
}

function listenIn(origId) {
  var url = '/portal/calls/tap/' + escapeCallid(origId);

  log(url);

  $.post(url, $.noop)
    .fail(function () {
      log('tap no good');
    })
    .done(function () {
      log('tap good');

      // sets height of dock column so it's displayed
      dockHeight();
    });
}

function listenButtonOnClick(event) {
  var $self = $(this);

  event.preventDefault();

  $self.prop('disabled', true);
  listenIn($self.data('orig-id'));
  jsFlash(_('Monitoring the Call...'), 'info');
}

function updateCallLineDomain(callData, showOrigSub) {
  var callRows = $('#calls_table > tbody > tr');
  var origCallid = callData.orig_callid;
  var termId = callData.term_callid;
  var termUri = callData.term_uri;
  var origName = callData.orig_name;
  var origSubName = callData.orig_sub_name;
  var rId = getCallKey(callData);
  var id = rId;
  var existingRow = $('#' + rId);
  var found;
  var trTag;
  var html;
  var status;

  if ($('#calls_table.queues-table').length > 0) {
    if ($('#calls_table.queues-table').attr('queue') != callData.term_sub
      && $('#calls_table.queues-table').attr('queue') != callData.by_sub
    ) {
      return;
    }

    if (callData.remove != 'yes' && termId !== '') {
      found = false;

      trTag = '';
      html = '';

      trTag += '<tr data-gmt-start="' + callData.time_start + '" orig_id="' + origCallid + '" term_id="'
        + termId + '" term_uri="' + termUri + '" id="' + id + '">';

      html += td(cleanDevice(callData.ani));

      if (showOrigSub) {
        html += td(origSubName);
      }

      html += td(origName);
      html += td(cleanDevice(callData.dnis));

      status = _('Talking');
      termUri = callData.term_uri;

      if (callData.term_uri === 'Call-Queue'
        || callData.term_uri === 'Auto-Attendant'
        || callData.term_uri === ' '
      ) {
        termUri = '';
        status = _('Waiting');
      } else if (callData.term_uri.indexOf('nms') !== -1
        && callData.term_uri.indexOf('corp') !== -1
        && callData.term_uri.indexOf('sipbx') !== -1
      ) {
        termUri = '';
        status = _('Waiting');
      } else if (callData.term_uri === 'CallBack-Queue') {
        termUri = '';
        status = _('Waiting for Callback');
      } else if (callData.time_answer === '0000-00-00 00:00:00') {
        status = _('Ringing Agent');
      } else if (callData.orig_call_info === 'held' && callData.term_call_info === 'held') {
        status = _('On Hold');
      }

      html += td(status);
      html += td(cleanDevice(termUri));
      html += td('<span data-gmt-start="' + callData.time_start + '" data-gmt-answer="' + callData.time_answer
        + '" class="duration_counter"></span>', 'text-right');

      html += getButtons(callData);
      trTag += html;
      trTag += '</tr  >';

      callRows.each(function (index) {
        if (callRows[index].id == rId) {
          // MODIFY
          $(this).html(html);
          found = true;
        }
      });

      if (!found) {
        $('#calls_table > tbody').last().append(trTag);
      }
    } else {
      // DELETE
      callRows.each(function (index) {
        if (callRows[index].id == rId) {
          $(this).remove();
        }
      });
    }
  } else if ($('#calls_table.waiting-table').length > 0) {
    if ($('#calls_table.waiting-table').attr('queue') != callData.term_sub
      && $('#calls_table.waiting-table').attr('queue') != callData.by_sub
    ) {
      return;
    }

    log(' waiting queue data');
    log(callData);

    if (callData.remove != 'yes') {
      log('updateCallLineDomain WAITING');

      found = false;

      id = origCallid;

      trTag = '';
      html = '';

      trTag += '<tr data-gmt-start="' + callData.time_start + '" orig_id="' + origCallid + '" id="'
        + origCallid + '">';

      html += td(cleanDevice(callData.ani));

      if (showOrigSub) {
        html += td(origSubName);
      }

      html += td(origName);

      status = _('Talking');
      termUri = callData.term_uri;

      if (callData.term_uri === 'Call-Queue'
        || callData.term_uri === 'Auto-Attendant'
        || callData.term_uri === ' '
      ) {
        termUri = '';
        status = _('Waiting');
      } else if (callData.term_uri === 'CallBack-Queue') {
        termUri = '';
        status = _('Waiting for Callback');
      } else if (callData.time_answer === '0000-00-00 00:00:00') {
        status = _('Ringing Agent');
      } else if (callData.orig_call_info === 'held' && callData.term_call_info === 'held') {
        status = _('On Hold');
      }

      html += td(status);
      html += td('<span data-gmt-start="' + callData.time_start + '" data-gmt-answer="' + callData.time_answer
        + '" class="duration_counter"></span>', 'text-right');

      html += getButtons(callData);
      trTag += html;
      trTag += '</tr  >';

      callRows.each(function (index) {
        if (callRows[index].id === origCallid) {
          if (status === _('Talking')) {
            $(this).remove();
          } else {
            // MODIFY
            $(this).html(html);
            found = true;
          }
        }
      });

      if (!found) {
        // ADD
        if (status !== _('Talking')) {
          $('#calls_table.waiting-table > tbody').last().append(trTag);
        }
      }
    } else {
      // DELETE
      callRows.each(function (index) {
        if (callRows[index].id === origCallid) {
          $(this).remove();
        }
      });
    }
  } else if (callData.remove !== 'yes') {
    log('updateCallLineDomain');
    log(callData);

    if (callData.media == 'VP8' || callData.media == 'VP9' || callData.media == 'H264') {
      if (callData.term_to_uri.includes('w@')) {
        return;
      }
    }

    if (callData.dnis.includes('video.bridge')) {
      callData.dnis = '';
    }

    var table = $('#calls_table');
    var callRow = $('<tr />')
      .attr('data-gmt-start', callData.time_start)
      .attr('orig_id', origCallid)
      .attr('term_id', termId)
      .attr('term_uri', termUri)
      .attr('id', rId);

    callRow.append($('<td />').text(cleanDevice(callData.ani)));

    if (showOrigSub) {
      callRow.append($('<td />').text(origSubName));
    }

    callRow.append($('<td />').text(origName));
    callRow.append($('<td />').text(cleanDevice(callData.dnis)));
    callRow.append($('<td />').text(cleanDevice(callData.term_uri)));

    var durationColHtml = $('<span />')
      .attr('data-gmt-start', callData.time_start)
      .attr('data-gmt-answer', callData.time_answer)
      .addClass('duration_counter');

    callRow.append(
      $('<td />')
        .addClass('text-right')
        .append(durationColHtml),
    );

    callRow.append(getButtons(callData, true));

    if (existingRow.length > 0) {
      existingRow.replaceWith(callRow);
    } else {
      table.find('tbody').last().append(callRow);
    }
  } else if (existingRow.length > 0) {
    // DELETE
    existingRow.remove();
  }

  var rowCount = callRows.length;
  var statsCalls = $('#stats-calls');

  if (typeof statsCalls !== 'undefined') {
    statsCalls.html('' + rowCount);
  }

  $('.nonecreated').toggle(!rowCount);

  if ($('#agents-table').length) {
    var listenButtonOrig = '#listen-' + cleanId(callData.orig_match);
    var listenButtonOrig2;

    if (!$(listenButtonOrig).length && typeof callData.orig_logi_uri !== 'undefined') {
      listenButtonOrig2 = '#listen-' + cleanId(callData.orig_logi_uri);

      if ($(listenButtonOrig2).length) {
        listenButtonOrig = listenButtonOrig2;
      }
    }

    var listenButtonTerm = '#listen-' + cleanId(callData.term_uri);

    if (typeof callData.term_uri !== 'undefined') {
      listenButtonTerm = '#listen-' + cleanId(callData.term_to_uri);
    }

    var listenButtonTerm2 = '#listen-' + cleanId(callData.term_match);
    var listenButtonTerm3 = '#listen-' + cleanId(callData.term_sub + '@' + callData.term_domain);

    listenButtonOrig2 = '#listen-' + cleanId(callData.orig_sub + '@' + callData.orig_domain);

    listenButtonTerm = listenButtonTerm.replace(/_/g, '-');
    listenButtonOrig = listenButtonOrig.replace(/_/g, '-');
    listenButtonTerm2 = listenButtonTerm2.replace(/_/g, '-');

    listenButtonOrig2 = listenButtonOrig2.replace(/_/g, '-');
    listenButtonTerm3 = listenButtonTerm3.replace(/_/g, '-');

    var callid = cleanId(callData.orig_callid);
    var listenButtons = [
      listenButtonTerm,
      listenButtonOrig,
      listenButtonTerm2,
      listenButtonOrig2,
      listenButtonTerm3,
    ];

    if (callData.remove == 'yes') {
      for (var i = 0; i < listenButtons.length; i++) {
        if ($(listenButtons[i]).length === 0) {
          // eslint-disable-next-line no-continue
          continue;
        }

        $(listenButtons[i]).each(function () {
          if ($(this).data('callid-out') === callid || $(this).data('callid-in') === callid) {
            $(this).attr('onclick', '');
            $(this).prop('disabled', true);
          }
        });
      }

      return;
    }

    if (callData.time_answer !== '0000-00-00 00:00:00') {
      for (var index = 0; index < listenButtons.length; index += 1) {
        var listenButton = $(listenButtons[index]);

        if (listenButton.length === 0) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if ($('#agents-table').hasClass('allowmonitor')
          && callData.term_uri !== 'Call-Queue'
          && callData.term_uri !== 'Auto-Attendant'
        ) {
          listenButton.data('orig-id', callData.orig_callid);
          listenButton.data('term-id', callData.term_callid);
          listenButton.data('orig-uri', callData.orig_uri);
          listenButton.data('term-uri', callData.term_uri);
          listenButton.data('ani', callData.ani);

          listenButton.off('click').on('click', listenButtonOnClick);
        }

        listenButton
          .removeAttr('disabled')
          .data('callid-in', callid);
      }
    }
  }

  var monId = getMonitorId(callData);

  $('.dockcall-column').each(function () {
    if ($(this).data('calltype') == 'monitor' && $(this).data('monitor-id') == monId) {
      dockModifyCallsameURI($(this), callData, 'Monitor', 'Monitor');
    }
  });
}

function durationCounter() {
  $('.duration_counter').each(
    function () {
      var gmtStart = $(this).data('gmt-start');
      var gmtAnswer = $(this).data('gmt-answer');

      if (!gmtAnswer || gmtAnswer === '0000-00-00 00:00:00') {
        if (!gmtStart || gmtStart === '0000-00-00 00:00:00') {
          $(this).text('');
        } else {
          $(this).text(getDuration(gmtStart, timeOffset));
        }
      } else if (gmtAnswer == 'ignore') {
        $(this).text(getDuration(gmtStart, timeOffset));
      } else {
        $(this).text(getDuration(gmtAnswer, timeOffset));
      }
    },
  );
}

/**
 * dial a number using the selected phone. set the default phone if selected
 *
 * @param {string} id is the id of a phones/devices select
 * @param {string} num is the number to be dialed
 * @param {boolean} [isAuto] whether call will be auto answered on click-to-call
 * */
function dialWithPhoneOption(id, num, isAuto) {
  if (isAuto === undefined) {
    isAuto = false;
  }

  var selection = cleanDevicePrep($('#' + id).val());

  if (selection == '' && $('#' + id.replace('select', 'text')).val()) {
    selection = $('#' + id.replace('select', 'text')).val();
  }

  if (!$('#' + id.replace('select', 'text')).is(':hidden')) {
    selection = cleanDevicePrep($('#' + id.replace('select', 'text')).val());
  }

  var defaultDevice = lookupDefaultDevice();

  num = cleanDevicePrep(num);

  console.log(selection);

  if (selection == 'webphone') {
    launchWebPhone(num);
  } else {
    clickToDial(subUser + '@' + subDomain, num, num, selection, isAuto);
  }

  if ($('#' + id + '-checkbox').is(':checked') && defaultDevice != selection) {
    $('.device-select').val(selection);
    localStorage.setItem('click2callphonedefaultvalue', selection);

    // timeout to let any visible popover hide first before destroying it and rebuilding
    setTimeout(function () {
      // have to rebuild the popover content if the default device is changed
      $('.make-call-options').popover('destroy');
      getUserDevices(false, createConfirmCallPopover);
    }, 200);
  }

  $('.make-call-options').popover('hide');
}

/**
 * sets the phone options for the phone select in the dial pad
 *
 * @param {object} devices is an object with all the user devices/phones
 * */
function setDialPadOptions(devices) {
  var deviceOptions = generateDeviceOptions(devices);

  if (deviceOptions.length) {
    $('#dial-pad-phone-option-select').html(deviceOptions);
    onchange = 'allowCustomNumber();';
  }
}

/**
 * shows the dial pad in the portal either as a dock popup or in the contacts popout
 *
 * @param {boolean} popout indicates whether we're showing the dial pad in the dock popup or popout
 * */
function showDialPad(popout) {
  if ($('.dial-pad').is(':visible')) {
    if (popout) {
      $('.dial-pad').remove();
      resizePopoutContent();

      return;
    }

    return;
  }

  // if needed, add unique id to "dock-column-dialpad" div in the dockHtml string below
  const dialPadHtml = `<div class="dial-pad">
    <div class="number-field-group2 input-group">
        <input class="form-control number-field"
               type="text"
               placeholder="${_('Extension or phone number')}">
        <span class="input-group-btn">
            <button class="btn btn-default clear" title="${_('Clear')}">
                <i class="glyphicon glyphicon-remove"></i>
            </button>
        </span>
    </div>
    <div class="btn-group dial-pad-keys">
        <button id="pad-1" class="btn btn-default" data-keycode="49" data-char="1">1<p>&nbsp;</p></button>
        <button id="pad-2" class="btn btn-default" data-keycode="50" data-char="2">2<p>ABC</p></button>
        <button id="pad-3" class="btn btn-default" data-keycode="51" data-char="3">3<p>DEF</p></button>
    </div>
    <div class="btn-group dial-pad-keys">
        <button id="pad-4" class="btn btn-default" data-keycode="52" data-char="4">4<p>GHI</p></button>
        <button id="pad-5" class="btn btn-default" data-keycode="53" data-char="5">5<p>JKL</p></button>
        <button id="pad-6" class="btn btn-default" data-keycode="54" data-char="6">6<p>MNO</p></button>
    </div>
    <div class="btn-group dial-pad-keys">
        <button id="pad-7" class="btn btn-default" data-keycode="55" data-char="7">7<p>PQRS</p></button>
        <button id="pad-8" class="btn btn-default" data-keycode="56" data-char="8">8<p>TUV</p></button>
        <button id="pad-9" class="btn btn-default" data-keycode="57" data-char="9">9<p>WXYZ</p></button>
    </div>
    <div class="btn-group dial-pad-keys last">
        <button id="pad-star" class="btn btn-default" data-keycode="42" data-char="*">*<p>&nbsp;</p></button>
        <button id="pad-0" class="btn btn-default" data-keycode="48" data-char="0">0<p>&nbsp;</p></button>
        <button id="pad-pound" class="btn btn-default" data-keycode="35" data-char="#">#<p>&nbsp;</p></button>
    </div>
    <div class="btn-group btn-block dial-pad-actions">
        <button class="btn btn-success dial-pad-call"><i class="answer"></i>${_('Call')}</button>
        <button class="btn btn-success dial-pad-from-btn" data-toggle="button" title="${_('Choose Phone')}">
            <span class="caret"></span>
        </button>
    </div>
    <div class="dial-pad-from"><p class="text-muted"><small>${_('Call using:')}</small></p>
        <p>
            <select id="dial-pad-phone-option-select"
                    class="form-control device-select isCallDropboxCheckbox"
                    onchange="uncheckDefaultDeviceBox('dial-pad-phone-option-select-checkbox')"></select>
        <p>
        <p class="isCallTextbox">
            <input id="dial-pad-phone-option-text" type="text" value="" placeholder="${_('Enter a phone number')}">
        </p>
        <p class="isCallDropboxCheckbox text-muted">
        <div class="checkbox">
            <label>
                <input id="dial-pad-phone-option-select-checkbox"
                       type="checkbox"
                       class="click2callphonedefault"
                       value="isDefault"
                       checked="">${_('Use this phone by default')}
            </label>
        </div>
        </p>
        <p class="isCallTextboxReset">
            <span id="changePhones" class="bluetext " onclick="setCustom(false)">${_('Choose another phone')}</span>
        </p>
    </div>
</div>`;

  if (popout) {
    // prepend popout html
    $('.popcall-container').prepend(dialPadHtml);

    $('.dial-pad').hide()
      .animate({
        height: 'show',
      }, {
        progress: function () {
          resizePopoutContent();
          $('.number-field').trigger('focus');
        },
      });
  } else {
    const dockHtml = `<div id="dock-column-dialpad" class="dock-column dockcall-column">
    <div class="dock-column-inner">
        <div class="dock-popup">
            <div class="dock-head">
                <div class="dock-head-buttons">
                    <span class="dockcall-onhold label label-danger hidden">${_('On Hold')}</span>
                    <button class="dock-minimize dock-head-button">
                        <i class="glyphicon glyphicon-chevron-down" title="${_('Minimize')}"></i>
                    </button>
                    <button class="dock-close dock-head-button">
                        <i class="glyphicon glyphicon-remove"></i>
                    </button>
                </div>
                <div class="dock-head-title">
                    <i class="fa fa-phone"></i><span class="dock-name">${_('Make a Call')}</span>
                </div>
            </div>
            <div class="dock-body dockcall-body">${dialPadHtml}</div>
        </div>
    </div>
</div>`;

    // prepend dock html
    $('.dock-popup-overlay').prepend(dockHtml);

    dockHeight();
    $('.number-field').trigger('focus');
  }

  var $numfield = $('.number-field');

  function keyPress(e) {
    var keyToggle = function (key) {
      var $keyObj = $('#pad-' + key);

      $keyObj.addClass('active');

      setTimeout(function () {
        $keyObj.removeClass('active');
      }, 100);
    };

    switch (e.code) {
      case 'Digit1':
      case 'Numpad1':
        if (!e.shiftKey) {
          keyToggle(1);
        }

        break;
      case 'Digit2':
      case 'Numpad2':
        if (!e.shiftKey) {
          keyToggle(2);
        }

        break;
      case 'Digit3':
        if (e.which == 35) {
          keyToggle('pound');
        } else {
          keyToggle(3);
        }

        break;
      case 'Numpad3':
        if (!e.shiftKey) {
          keyToggle(3);
        }

        break;
      case 'Digit4':
      case 'Numpad4':
        if (!e.shiftKey) {
          keyToggle(4);
        }

        break;
      case 'Digit5':
      case 'Numpad5':
        if (!e.shiftKey) {
          keyToggle(5);
        }

        break;
      case 'Digit6':
      case 'Numpad6':
        if (!e.shiftKey) {
          keyToggle(6);
        }

        break;
      case 'Digit7':
      case 'Numpad7':
        if (!e.shiftKey) {
          keyToggle(7);
        }

        break;
      case 'Digit8':
        if (e.which == 42) {
          keyToggle('star');
        } else {
          keyToggle(8);
        }

        break;
      case 'Numpad8':
        if (!e.shiftKey) {
          keyToggle(8);
        }

        break;
      case 'Digit9':
      case 'Numpad9':
        if (!e.shiftKey) {
          keyToggle(9);
        }

        break;
      case 'Digit0':
      case 'Numpad0':
        if (!e.shiftKey) {
          keyToggle(0);
        }

        break;
      case 'NumpadEnter':
      case 'Enter':
      case 13:
        if (e.type !== 'keydown') {
          $('.dial-pad-call').trigger('click');
        }

        break;
      default:
        break;
    }
  }

  $numfield[0].onkeypress = function (e) {
    keyPress(e);
  };

  $('.dial-pad-keys button').on('click', function () {
    var ch = $(this).data('char');

    $numfield.insertAtCaret(ch);
  });

  $('.clear').on('click', function () {
    // change numfield jquery object to DOM element
    var e = $numfield[0];

    // remove selected part of string at cursor
    if (e.selectionStart || e.selectionStart == '0') {
      var startPos = e.selectionStart;
      var endPos = e.selectionEnd;

      if (startPos != endPos) {
        e.value = e.value.substring(0, startPos) + e.value.substring(endPos, e.value.length);
        e.focus();
        e.selectionStart = startPos;
        e.selectionEnd = startPos;
      } else {
        e.value = e.value.substring(0, startPos - 1) + e.value.substring(endPos, e.value.length);
        e.focus();
        e.selectionStart = startPos - 1;
        e.selectionEnd = startPos - 1;
      }
    } else {
      // or clear entire field if can't find selection/cursor
      e.value = '';
    }
  });

  $('.dial-pad-call').on('click', function () {
    var number = $numfield.val();

    number = number.replace(/\./g, '');

    if (number.length > 0) {
      dialWithPhoneOption('dial-pad-phone-option-select', number);
    }
  });

  // show call from field when button is clicked
  $('.dial-pad-from-btn').on('click', function () {
    if ($('.dial-pad-from').is(':visible')) {
      $('.dial-pad-from').animate(
        { height: 'hide', opacity: 'hide' },
        {
          progress: function () {
            if (popout) {
              resizePopoutContent();
            }
          },
        },
      );
    } else {
      $('.dial-pad-from').animate(
        { height: 'show', opacity: 'show' },
        {
          progress: function () {
            if (popout) {
              resizePopoutContent();
            }
          },
        },
      );
    }
  });

  $('#dial-pad-phone-option-select').on('change', function () {
    $('#dial-pad-phone-option-select-checkbox').prop('checked', false);
  });

  if ($('#dial-pad-phone-option-select').length) {
    getUserDevices(false, setDialPadOptions);
  }
}

/**
 * compare current and default devices in the phone options select and get dropdown direction
 *
 * @param {object} el is the button element that triggers the phone option dropdown
 * */
function clickedCallDropdownToggle(el) {
  // reset phone select and default checkbox
  var defaultDevice = lookupDefaultDevice();
  var $select = $(el).next('.dropdown-menu')
    .find('.device-select');
  var selectedDevice = $select.val();

  if (selectedDevice != defaultDevice) {
    $select.val(defaultDevice);

    $(el).next('.dropdown-menu')
      .find('.click2callphonedefault')
      .prop('checked', true);
  }

  // determine if dropdown goes up or down
  getDropdownDirection(el);
}

/**
 * initialize confirm call popover on elements with 'make-call' class
 *
 * */
function initConfirmCall() {
  log('adding confirm call');

  if ($('a.make-call').length > 0 && typeof $(document).confirmCall === 'function') {
    $('a.make-call').each(function () {
      var num = $(this).text();

      $(this).confirmCall({
        message: num,
      });
    });
  } else if ($('.make-call-options').length > 0 && typeof $(document).popover === 'function') {
    getUserDevices(false, createConfirmCallPopover);
  }
}

function setCustom(enable) {
  if (enable) {
    $('.isCallTextbox').show();
    $('.isCallTextboxReset').show();
    $('.isCallDropbox').hide();
    $('.isCallDropboxCheckbox').hide();
    $('.isnumberreset').show();
  } else {
    $('.isCallTextbox').hide();
    $('.isCallTextboxReset').hide();
    $('.isCallDropbox').show();
    $('.isCallDropboxCheckbox').show();
    $('.isnumberreset').hide();
    $('.isCallTextbox input').val('');

    $('.device-select').val(
      $('.device-select')
        .first()
        .find('option')
        .first()
        .val(),
    );
  }
}

/**
 * set default device checkbox to false
 *
 * @param {string} id is the id of a default device checkbox
 * */
function uncheckDefaultDeviceBox(id) {
  if ($('#' + id.replace('-checkbox', '')).val() == null
    || $('#' + id.replace('-checkbox', '')).val() == ''
  ) {
    setCustom(true);
  }

  $('#' + id).prop('checked', false);
}

/**
 * generate and append the options for the phone/devices select
 *
 * @param {object} devices is an object with all the user devices/phones
 * */
function createConfirmCallOptionsDock(devices) {
  var deviceOptions = generateDeviceOptions(devices);

  if (deviceOptions.length) {
    // majority of phone options html is php generated and we just insert the options here
    $('.device-select-dock').each(function () {
      $(this).html(deviceOptions);
    });
  }

  // prevent dropdown from closing when selecting option or checkbox
  $('.dropdown-menu-phone-select').on('click', function (e) {
    e.stopPropagation();
  });
}

// eslint-disable-next-line no-unused-vars
function transferCallDirect(toUser) {
  var calltype;

  if (callToTransfer.orig_callid) {
    log(callToTransfer);

    calltype = getType(callToTransfer, subDomain, subUser);
  } else {
    return;
  }

  if (typeof ignoreOrigId !== 'undefined') {
    ignoreOrigId.push(callToTransfer.orig_callid);
    ignoreOrigId.push(callToTransfer.term_callid);
  }

  var url = '/portal/calls/xfer/';

  $(this).prop('disabled', true);

  if (calltype == 'outbound') {
    url = url + myCalls[0].term_callid + '/' + toUser;
  } else {
    url = url + myCalls[0].orig_callid + '/' + toUser;
  }

  log(url);

  $.post(url, $.noop)
    .fail(console.error)
    .done(function () {
      closeTransferMode();
      jsFlash(_('Transferring call to {0}', toUser), 'success');
    });
}

var callsSocketHandlersBound = false;

// Each sGetCallsData() call describes one call-line view: the domain and filter
// its rows are scoped to, and whether it renders the popout variant. The 'call'
// handler is bound once, so it reads from this list instead of closing over a
// single set of arguments - a page can show more than one view (the layout
// subscribes for the logged-in user, and the queued-calls modal subscribes for a
// queue), and both have to keep updating.
var callLineContexts = [];

/**
 * Record a call-line view, ignoring one that is already registered.
 *
 * @param {string} domain is the domain the view's rows belong to
 * @param {string} filter is the user, site or queue the view is scoped to
 * @param {boolean} popout is true when the view renders the popout variant
 */
function registerCallLineContext(domain, filter, popout) {
  var exists = callLineContexts.some(function (context) {
    return context.domain === domain
      && context.filter === filter
      && context.popout === popout;
  });

  if (exists) {
    return;
  }

  callLineContexts.push({ domain: domain, filter: filter, popout: popout });
}

/**
 * Forget a call-line view whose rows have left the document, so later call
 * events stop updating a table that is no longer on the page. Views that live
 * as long as the page never need this; modals do.
 *
 * @param {string} domain is the domain the view's rows belong to
 * @param {string} filter is the user, site or queue the view is scoped to
 * @param {boolean} popout is true when the view renders the popout variant
 */
function unregisterCallLineContext(domain, filter, popout) {
  callLineContexts = callLineContexts.filter(function (context) {
    return context.domain !== domain
      || context.filter !== filter
      || context.popout !== popout;
  });
}

function sGetCallsData(type, domain, filter, popout) {
  if (typeof popout === 'undefined') {
    popout = false;
  }

  if (typeof socket === 'undefined') {
    return;
  }

  var options = {
    domain: domain,
    type: 'call',
  };

  if (typeof type !== 'undefined' && type != '' && type != 'user') {
    options.subtype = type;
  }

  if (typeof filter !== 'undefined' && filter != '' && filter != '*') {
    options.filter = filter;
  }

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscribeOnce(options);
    });

  registerCallLineContext(domain, filter, popout);

  // Register the call handlers only once. This function is reached again on
  // every socket reconnect, and several views call it more than once per page,
  // so registering unconditionally meant each call event was processed - and
  // each modal reloaded - once per registration.
  if (callsSocketHandlersBound) {
    return;
  }

  callsSocketHandlersBound = true;

  socket.on('call-domain', function (data) {
    if (portalHomeOmpShowMeetings) {
      if (data.term_to_uri.includes('.video.bridge') || data.orig_from_uri.includes('.video.bridge')) {
        return;
      }

      if (data.term_to_uri.includes('conference-bridge') || data.orig_from_uri.includes('conference-bridge')) {
        return;
      }
    }

    UiConfigReaderComponent.isConfigEnabled('PORTAL_HOME_ACTIVE_CALLS_SHOW_ORIG_SUB')
      .then(function (isOrigSubEnabled) {
        updateCallLineDomain(data, isOrigSubEnabled);
      });

    if (data.orig_from_user != 'Call-Record-Account' || data.remove != 'yes') {
      return;
    }

    log('Call to record ended');

    var greetingEnd = false;
    var greetingsModal;
    var path;

    // check to see if any greetings modals are showing
    if ($('#greetings-modal').is(':visible')) {
      log('greetings-modal is visible');
      greetingsModal = $('#greetings-modal');
      path = '/portal/users/greetings/index/' + data.by_sub + '@' + data.by_domain;
      greetingEnd = true;
    } else if ($('#introgreeting-modal').is(':visible')) {
      log('introgreeting-modal is visible');
      greetingsModal = $('#introgreeting-modal');

      var calleeMatch = greetingsModal.data('callee-match');
      var starting = greetingsModal.data('starting');

      path = '/portal/attendants/intros/' + calleeMatch + '/' + starting;
      greetingEnd = true;
    } else if ($('#write-queue').is(':visible')) {
      log('write queue modal is visible');

      var queue = $('#CallQueueName').val();

      log(queue);

      var jsonPath = '/portal/callqueues/messageCheck/' + queue;

      // grab new recording uri, insert into play and download buttons
      setTimeout(function () {
        $.getJSON(jsonPath, function (messageCheckResults) {
          log('new remotepath for announce-to-agent.wav');

          var remotePath = messageCheckResults.remotepath;

          if ($('#audio-player-1').length) {
            // removes the HTML characters added
            remotePath = remotePath.replace(/\bamp;\b/g, '');

            $('#write-queue .download-audio-btn').attr('href', remotePath);

            $('#audio-player-1 source').each(function () {
              log('updating audio players source paths');

              var audioType = $(this).attr('type');

              if (audioType == 'audio/x-wav') {
                remotePath += '&convert=signed';
              } else if (audioType == 'audio/ogg; codecs=vorbis') {
                remotePath += '&convert=ogg';
              } else if (audioType == 'audio/mp4') {
                remotePath += '&convert=aac';
              } else if (audioType == 'audio/aac') {
                remotePath += '&convert=aac';
              }

              log(remotePath);

              $(this).attr('src', remotePath);
            });

            // loads new sources to audio player
            $('#audio-player-1')[0].load();
            hideAgentMsgRecord();
          } else {
            log('no audio player found');
          }
        }).fail(function () {
          log('remotepath request failed');
          jsFlash(_('Message to agent failed to record!'), 'danger');
        });
      }, 2000);
    } else if ($('#write-rule').is(':visible')) {
      // check if edit answering rule is open
      hideAgentMsgRecord();
    }

    // after call to record ends, refresh greetings modal if it's visible
    if (greetingEnd) {
      log('a greetings modal is visible, reloading modal');

      path = greetingsModal.find('form').attr('action');
      greetingsModal.find('.modal-content').html(modalLoadingHtml);

      setTimeout(function () {
        log('reloading greetings modal');
        greetingsModal.find('.modal-content').load(path, function () {
          greetingsTableHeight();
        });
      }, 2000);
    }
  });

  socket.on('call-queue', function (data) {
    log('call-queue');
    log(data);

    UiConfigReaderComponent.isConfigEnabled('PORTAL_HOME_ACTIVE_CALLS_SHOW_ORIG_SUB')
      .then(function (isOrigSubEnabled) {
        updateCallLineDomain(data, isOrigSubEnabled);
      });
  });

  socket.on('call', function (event) {
    log('socket call');

    if (event.orig_from_user == 'Call-Record-Account' && event.remove == 'yes') {
      log('Call to record ended');

      var greetingEnd = false;
      var greetingsModal;
      var $modalContent;
      var path;

      // check to see if any greetings modals are showing
      if ($('#greetings-modal').is(':visible')) {
        log('greetings-modal is visible');
        greetingsModal = $('#greetings-modal');
        path = '/portal/users/greetings/index/' + event.by_sub + '@' + event.by_domain;
        greetingEnd = true;
      } else if ($('#introgreeting-modal').is(':visible')) {
        log('introgreeting-modal is visible');
        greetingsModal = $('#introgreeting-modal');

        var calleeMatch = greetingsModal.data('callee-match');
        var starting = greetingsModal.data('starting');

        path = '/portal/attendants/intros/' + calleeMatch + '/' + starting;
        greetingEnd = true;
      } else if ($('#write-queue').is(':visible')) {
        log('write queue modal is visible');

        var queue = $('#CallQueueName').val();

        log(queue);

        var jsonPath = '/portal/callqueues/messageCheck/' + queue;

        // grab new recording uri, insert into play and download buttons
        setTimeout(function () {
          $.getJSON(jsonPath, function (data) {
            log('new remotepath for announce-to-agent.wav');

            var remotePath = data.remotepath;

            if ($('#audio-player-1').length) {
              // removes the HTML characters added
              remotePath = remotePath.replace(/\bamp;\b/g, '');

              $('#write-queue .download-audio-btn').attr('href', remotePath);

              $('#audio-player-1 source').each(function () {
                log('updating audio players source paths');

                var audioType = $(this).attr('type');

                if (audioType == 'audio/x-wav') {
                  remotePath += '&convert=signed';
                } else if (audioType == 'audio/ogg; codecs=vorbis') {
                  remotePath += '&convert=ogg';
                } else if (audioType == 'audio/mp4') {
                  remotePath += '&convert=aac';
                } else if (audioType == 'audio/aac') {
                  remotePath += '&convert=aac';
                }

                log(remotePath);

                $(this).attr('src', remotePath);
              });

              // loads new sources to audio player
              $('#audio-player-1')[0].load();
              hideAgentMsgRecord();
            } else {
              log('no audio player found');
            }
          })
            .fail(function () {
              log('remotepath request failed');
              jsFlash(_('Message to agent failed to record!'), 'danger');
            });
        }, 2000);
      } else if ($('#write-rule').is(':visible')) {
        // check if edit answering rule is open
        hideAgentMsgRecord();
      }

      $modalContent = greetingsModal.find('.modal-content');

      // after call to record ends, refresh greetings modal if it's visible
      if (greetingEnd) {
        log('a greetings modal is visible, reloading modal');

        path = greetingsModal.find('form').attr('action');
        $modalContent.html(modalLoadingHtml);

        setTimeout(function () {
          log('reloading greetings modal');

          $modalContent.load(path, function () {
            greetingsTableHeight();
          });
        }, 2000);
      }

      return;
    }

    if (event.orig_from_user == 'Call-Record-Account') {
      return;
    }

    callLineContexts.forEach(function (context) {
      if (context.filter === '*') {
        return;
      }

      if (!context.popout) {
        updateCallLineUser(event, context.domain, context.filter);
      } else {
        updateCallLineUserPopout(event, context.domain, context.filter);
      }
    });
  });
}

$(window).on('blur focus', function (e) {
  if ($(window).data('prevType') != e.type) {
    //  reduce double fire issues
    switch (e.type) {
      case 'blur':
        break;
      case 'focus':
        // do work
        break;
      default:
    }
  }

  $(window).data('prevType', e.type);
});

$(function () {
  if (typeof servertime !== 'undefined') {
    timeOffset = getSecDiffUtc(servertime);
  }

  setInterval(durationCounter, 1000);
});
